import { FUNCTIONAL_GROUPS } from "../data/functional-groups.data";
import { PROTON_TYPES } from "../data/proton-types.data";

type SampleId = string;

export interface FunctionalGroup {
  assigned: any; // Replace `any` with the actual type if known
  splitting?: number; // Optional property
  hydrogens?: number; // Optional property
}

interface Build {
  assign: any[]; // Replace `any` with the actual type if known
  groupId?: string;
  isBase?: boolean;
  moleculeId?: string;
  options?: { showHydrogen: boolean }; // This is required
  rangeId?: string;
  structure: string | { atoms: any[]; bonds: any[] }; // Adjust types as necessary
}

interface Answer {
  ranges: { [key: string]: FunctionalGroup };
  build?: Build;
}

export const ANSWERS: Record<SampleId, Answer> = {
  cherry: {
    ranges: {
      "ede7dbdb-5a01-4941-acb1-709c0f064c6f": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "1220cc95-4818-4d36-8eaa-022992db3216": {
        assigned: FUNCTIONAL_GROUPS[2],
      },
      "2e42c0a0-0fa7-420f-acfa-d02a3457d9c8": {
        assigned: FUNCTIONAL_GROUPS[3],
      },
      "20fbcc2d-d611-4f20-9717-7651deef6781": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "8a8212b6-f992-404d-82a0-48f324caa14c": {
        assigned: PROTON_TYPES[26],
        splitting: 1,
        hydrogens: 1,
      },
      "10ac89c5-3956-4c36-b981-3ac93c7a5164": {
        assigned: PROTON_TYPES[8],
        splitting: 2,
        hydrogens: 2,
      },
      "6fecaa4e-052d-47f9-bde0-fe10f19e38f9": {
        assigned: PROTON_TYPES[8],
        splitting: 3,
        hydrogens: 1,
      },
      "018b6748-a39d-4b3f-a346-8a75e176d302": {
        assigned: PROTON_TYPES[8],
        splitting: 3,
        hydrogens: 2,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            groupId: "9a4a8217-54f1-4c95-88c1-522ad49731fb",
            moleculeId: "12e5f453-c0f7-49df-83ce-c3aba3ffa55c",
            options: {
              showHydrogen: true,
            },
            rangeId: "018b6748-a39d-4b3f-a346-8a75e176d302-0",
            structure: "hydrogen",
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "657efcec-9d78-4574-b7b2-4718c0ded3fc",
            isBase: true,
            moleculeId: "7cd541df-b31f-4ce5-88e6-1f244470c32c",
            options: {
              showHydrogen: true,
            },
            rangeId: "8a8212b6-f992-404d-82a0-48f324caa14c-0",
            structure: "aldehyde",
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "1d80b2d0-f319-4067-8490-1cf4f9f01601",
            isBase: true,
            moleculeId: "95ae923d-2429-4507-8ee4-23862a97cc9d",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "27b67a11-e049-4868-a1fc-3db889a0bb14",
            isBase: true,
            moleculeId: "d84a2238-6c36-4855-8588-d72c714d3f0f",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "bd94bd6e-eebb-4048-b955-837a6742e730",
            isBase: true,
            moleculeId: "33310624-a3fa-484f-a8a4-81ec5d078935",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "24463b7f-02dd-4e9a-9d3f-f2ac02208128",
            isBase: true,
            moleculeId: "79369acf-420d-4711-9705-b7b7ac05ea16",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
      ],
      groupId: "9a4a8217-54f1-4c95-88c1-522ad49731fb",
      isBase: true,
      moleculeId: "6d57ea07-82f9-4f4d-9036-63a42942e9ca",
      options: {
        showHydrogen: true,
      },
      rangeId: "018b6748-a39d-4b3f-a346-8a75e176d302-0",
      structure: "aromatic-ring-empty",
    },
  },
  beer: {
    ranges: {
      "1ec64d64-91b5-4311-ab08-d88a6e57db5d": {
        assigned: FUNCTIONAL_GROUPS[12],
      },
      "0fa3f193-a657-4989-8585-98f7ae3237bf": {
        assigned: FUNCTIONAL_GROUPS[4],
      },
      "600e3cba-bc27-4650-98da-278166f38d75": {
        assigned: FUNCTIONAL_GROUPS[5],
      },
      "ee96815c-db3e-4fa0-a90c-8cb1a47bf6de": {
        assigned: PROTON_TYPES[4],
        splitting: 1,
        hydrogens: 1,
      },
      "0e851a79-ddaf-4cfc-98dd-0b289b44c867": {
        assigned: PROTON_TYPES[8],
        splitting: 1,
        hydrogens: 1,
      },
      "58a100cd-b32d-4337-80aa-601c0c207d95": {
        assigned: PROTON_TYPES[32],
        splitting: 1,
        hydrogens: 1,
      },
      "7f9adff5-8172-465d-a9fd-f4ca30731e8f": {
        assigned: PROTON_TYPES[9],
        splitting: 3,
        hydrogens: 2,
      },
      "a52d1a76-748a-4da8-9723-182cad8e8aba": {
        assigned: PROTON_TYPES[9],
        splitting: 3,
        hydrogens: 2,
      },
    },
  },
  "yogurt-cup": {
    ranges: {
      "e6de3594-26f1-466d-985c-df73538b8cba": {
        assigned: FUNCTIONAL_GROUPS[17],
      },
      "cc4edd87-dcc5-454c-a794-0eac1310e0a2": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "2b3a1e5b-69b0-4490-a9be-3529bf76fc9e": {
        assigned: FUNCTIONAL_GROUPS[16],
      },
      "cf7a3ffb-128c-4b6b-ae39-f6bdd146d241": {
        assigned: PROTON_TYPES[31],
        splitting: 4,
        hydrogens: 1,
      },
      "2c296aa1-6086-4d5d-baa8-25912e66dc29": {
        assigned: PROTON_TYPES[0],
        splitting: 2,
        hydrogens: 3,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "146a57e5-797f-4464-8eaa-1d4b1758f15e",
                  moleculeId: "7d50613d-1c48-4197-8687-b682dffc95a1",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "cf7a3ffb-128c-4b6b-ae39-f6bdd146d241-0",
                  structure: "alcohol",
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "d5f762bf-b196-4f87-8391-0c0b2b448323",
                  isBase: true,
                  moleculeId: "ffd3cb72-afa3-4765-9021-8349847b9c65",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "2c296aa1-6086-4d5d-baa8-25912e66dc29-0",
                  structure: "ch3",
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "146a57e5-797f-4464-8eaa-1d4b1758f15e",
            isBase: true,
            moleculeId: "2131d2a4-1207-4e83-ba2c-790c2dc0371a",
            options: {
              showHydrogen: true,
            },
            rangeId: "cf7a3ffb-128c-4b6b-ae39-f6bdd146d241-0",
            structure: "ch",
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
      ],
      groupId: "517e3514-7b12-44c3-b07f-569a7dca95be",
      isBase: true,
      moleculeId: "f0b36d9e-88a7-4787-909e-a6179d4f8382",
      rangeId: "e6de3594-26f1-466d-985c-df73538b8cba-0",
      structure: "carboxylic-acid",
    },
  },
  "wine-cork": {
    ranges: {
      "b532dcea-cb38-4820-9f23-ae580c006c52": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "3af166c6-a1db-43ea-8b50-1f53c4769360": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "73e5c542-d561-4980-8c7b-b8469a2ade23": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "bd0e573f-16ed-4075-b00e-5eecee13907a": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "6444e09a-dc56-494e-985b-43da040ad073": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "69cd2897-70d8-4578-851b-29b46e5c6b04": {
        assigned: FUNCTIONAL_GROUPS[21],
      },
      "3506a0b6-6a77-4e54-8373-ff60dffcfdea": {
        assigned: PROTON_TYPES[8],
        splitting: 1,
        hydrogens: 2,
      },
      "a0217a2c-707d-4b22-bbd4-f8d98fd03e81": {
        assigned: PROTON_TYPES[18],
        splitting: 1,
        hydrogens: 3,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            groupId: "9f1858f5-49fe-459d-8f02-2699c2b098d9",
            isBase: true,
            moleculeId: "77530dff-99a2-413a-87a2-ad19f26cbead",
            rangeId: "69cd2897-70d8-4578-851b-29b46e5c6b04-0",
            structure: "chlorine",
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "ae3f6ad8-b8ef-4510-8ec5-e518aac48fe9",
            isBase: true,
            moleculeId: "651e6be4-a9c2-4076-af08-9df703ee242a",
            rangeId: "69cd2897-70d8-4578-851b-29b46e5c6b04-0",
            structure: "chlorine",
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "335cc203-ce3e-4cf5-b2ed-5ac508b287cc",
            isBase: true,
            moleculeId: "1a105cb9-8753-42a1-a1ce-acd3b5820f11",
            rangeId: "69cd2897-70d8-4578-851b-29b46e5c6b04-0",
            structure: "chlorine",
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "486441d9-e77e-4338-9d76-54e0d9d9d0db",
            isBase: true,
            moleculeId: "f58aca9d-83f8-4022-b564-1f3b3ce0ce35",
            rangeId: "undefined-0",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "61f0d3ae-9e4c-46e1-a60d-f787197adff3",
            isBase: true,
            moleculeId: "17adbea7-a755-44af-90b7-b225d901b6db",
            rangeId: "undefined-0",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "214d9750-a9d6-4adc-8b11-bac6c27fd8b9",
                        isBase: true,
                        moleculeId: "57a9e002-5ad8-4de9-901e-08b8e058ff5b",
                        rangeId: "undefined-0",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "7030e01c-8393-48e7-8e73-b49df2a5275d",
                        isBase: true,
                        moleculeId: "815c3ba5-e4f1-4405-a842-39f3696ad366",
                        rangeId: "undefined-0",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r1",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "421546c7-3cd7-4923-b8c1-fddec47c74f0",
                  moleculeId: "7885d97d-049b-4ed2-8f1d-921eabc988be",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "a0217a2c-707d-4b22-bbd4-f8d98fd03e81-0",
                  structure: "ch",
                },
                parentAtom: "r1",
                sourceAtom: "r2",
              },
            ],
            groupId: "421546c7-3cd7-4923-b8c1-fddec47c74f0",
            isBase: true,
            moleculeId: "d605ae32-f9d8-40d9-994c-7f17c7601687",
            options: {
              showHydrogen: true,
            },
            rangeId: "a0217a2c-707d-4b22-bbd4-f8d98fd03e81-0",
            structure: "oxygen",
          },
          parentAtom: "r1",
          sourceAtom: "r2",
        },
      ],
      groupId: "15e270d7-166e-47b1-ad20-fbfb13dc30dc",
      isBase: true,
      moleculeId: "6d134813-5545-4017-b155-49d9844dc68c",
      rangeId: "bd0e573f-16ed-4075-b00e-5eecee13907a-0",
      structure: "aromatic-ring-empty",
    },
  },
  water: {
    ranges: {
      "cc5ec67d-fa56-42c5-a6ba-eed1aa05c082": {
        assigned: FUNCTIONAL_GROUPS[0],
      },
      "812e7f06-0ff2-409d-b67b-85cd44593eb1": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "0b7e4a84-315f-491c-8860-f7674bd018cf": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "cb83e39b-57ab-4f1e-91ac-a914d40c4800": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "1cdaef02-aa4f-4ebe-9d55-cd20a1bc4764": {
        assigned: FUNCTIONAL_GROUPS[21],
      },
      "c18adb93-8b03-4fe8-984e-4de11b4251b2": {
        assigned: PROTON_TYPES[8],
        splitting: 1,
        hydrogens: 2,
      },
      "2d10d4b6-ecc8-4afd-97f7-200e11837588": {
        assigned: PROTON_TYPES[12],
        splitting: 1,
        hydrogens: 1,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            groupId: "4b26bd66-bcc5-4021-9672-2abb200ad1ed",
            isBase: true,
            moleculeId: "7907720e-4c1b-433f-9fb0-24e002b220eb",
            rangeId: "cc5ec67d-fa56-42c5-a6ba-eed1aa05c082-0",
            structure: "alcohol",
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "430bc7de-d2e6-430c-a563-11fcb5d0c758",
            isBase: true,
            moleculeId: "a35bfd22-fb74-45c7-ac0f-e87ee19c4e32",
            rangeId: "1cdaef02-aa4f-4ebe-9d55-cd20a1bc4764-0",
            structure: "chlorine",
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "2839f4d9-7fc4-4da6-b801-b56f4c55393f",
            isBase: true,
            moleculeId: "feb347a8-c99b-4e25-8374-d29a95984cbd",
            rangeId: "1cdaef02-aa4f-4ebe-9d55-cd20a1bc4764-0",
            structure: "chlorine",
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "bb2416f8-2460-4e46-b3af-72a199ca1b8e",
            isBase: true,
            moleculeId: "66588252-fe6b-454d-a6c1-0841236b9bfc",
            rangeId: "1cdaef02-aa4f-4ebe-9d55-cd20a1bc4764-0",
            structure: "chlorine",
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "3f439f7c-a9f4-4bb0-8dac-4b1d71c9ae5e",
            isBase: true,
            moleculeId: "21788ecd-75be-43b6-afd9-c0cd391f2552",
            rangeId: "undefined-0",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "a440c563-f8f3-4995-b421-32e5a7c53e23",
            isBase: true,
            moleculeId: "905423f6-02e1-4b40-a299-dbe131cac59f",
            rangeId: "undefined-0",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
      ],
      groupId: "9ac3ba97-b2fd-435f-bfee-3f7672f098b8",
      isBase: true,
      moleculeId: "61231296-61cd-4138-8303-5ff6f39c0c4c",
      rangeId: "812e7f06-0ff2-409d-b67b-85cd44593eb1-0",
      structure: "aromatic-ring-empty",
    },
  },
  currants: {
    ranges: {
      "cf26e11e-8c05-42a0-aef3-3a3fff991978": {
        assigned: FUNCTIONAL_GROUPS[17],
      },
      "81842cb5-26e8-43fd-b605-b0cbde9463c6": {
        assigned: FUNCTIONAL_GROUPS[16],
      },
      "6e112eb2-ffc0-419d-991c-e8c2271a10a1": {
        assigned: PROTON_TYPES[22],
        splitting: 1,
        hydrogens: 4,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            groupId: "90891dcd-d643-418b-bb39-605988f94f31",
            moleculeId: "b1a3083e-9855-4d65-8347-b59a0f966f37",
            options: {
              showHydrogen: true,
            },
            rangeId: "6e112eb2-ffc0-419d-991c-e8c2271a10a1-0",
            structure: "carboxylic-acid",
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "8cd7c401-e4cf-48c0-bf39-85828654c712",
                  moleculeId: "3bd1e229-b206-4ed1-8b97-9916ecba3a0b",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "6e112eb2-ffc0-419d-991c-e8c2271a10a1-0",
                  structure: "carboxylic-acid",
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "74807045-4d43-44b0-9a6e-3a93c331f01d",
                  isBase: true,
                  moleculeId: "30abd67e-ca4b-46f8-8c3c-4f9392ef17ed",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "8cd7c401-e4cf-48c0-bf39-85828654c712",
            isBase: true,
            moleculeId: "00eef001-b0a4-4027-83ea-06f25e31e01d",
            options: {
              showHydrogen: true,
            },
            rangeId: "6e112eb2-ffc0-419d-991c-e8c2271a10a1-0",
            structure: "ch",
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "508212a7-336e-45fe-9350-a8454b5f6530",
            isBase: true,
            moleculeId: "798cc024-f433-4110-a4b0-ad3dac7bf591",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
      ],
      groupId: "90891dcd-d643-418b-bb39-605988f94f31",
      isBase: true,
      moleculeId: "6ee3fca3-d9ac-45e9-83c2-448cabc67aed",
      options: {
        showHydrogen: true,
      },
      rangeId: "6e112eb2-ffc0-419d-991c-e8c2271a10a1-0",
      structure: "ch",
    },
  },
  "chocolate-bar": {
    ranges: {
      "97d9cc90-9398-486d-9b68-1ac3d6f8664b": {
        assigned: FUNCTIONAL_GROUPS[12],
      },
      "110903cb-1ab4-4408-8e12-d270a9d198de": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "2b278e04-667c-4f84-acda-513f476df8bd": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "cae6b928-88c8-46fe-8e90-7a515bc6e400": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "2b85c991-c1d1-4d88-b529-d38f64777b2d": {
        assigned: PROTON_TYPES[8],
        splitting: 9,
        hydrogens: 5,
      },
      "0590cfde-e3b5-4cbe-b330-a3f8f408974b": {
        assigned: PROTON_TYPES[33],
        splitting: 3,
        hydrogens: 2,
      },
      "e8e0908a-4bc4-40eb-a042-1564137041fd": {
        assigned: PROTON_TYPES[9],
        splitting: 3,
        hydrogens: 2,
      },
      "973ff21b-ccbe-47db-bb44-2e08b9830b62": {
        assigned: PROTON_TYPES[32],
        splitting: 1,
        hydrogens: 2,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "2d9a565b-f54f-45b8-ae83-ffd2d98f1c00",
                        moleculeId: "d8d25899-dcad-434d-8983-06e61422b18b",
                        options: {
                          showHydrogen: true,
                        },
                        rangeId: "0590cfde-e3b5-4cbe-b330-a3f8f408974b-0",
                        structure: "amine",
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "a1645ccd-6188-45a2-96dd-f69428f2f4d8",
                        isBase: true,
                        moleculeId: "1db2d51e-6827-4506-bff4-629cda1b5d3a",
                        rangeId: "default",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "2d9a565b-f54f-45b8-ae83-ffd2d98f1c00",
                  isBase: true,
                  moleculeId: "950a5fd4-5d1d-48b4-8548-ece1a188a798",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "0590cfde-e3b5-4cbe-b330-a3f8f408974b-0",
                  structure: "ch",
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "5960e13d-1a13-474a-80d9-3c39ed1e3953",
            moleculeId: "b93e0ffe-b273-4499-8829-5cad4ac7ebcb",
            options: {
              showHydrogen: true,
            },
            rangeId: "e8e0908a-4bc4-40eb-a042-1564137041fd-0",
            structure: "ch2",
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "4ef3be92-ee02-4cce-aba7-2fb0ebd1c8c3",
            isBase: true,
            moleculeId: "ab03bff1-92b7-467b-9a74-f098a2b0c4d5",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "f4785d15-5c94-4624-aeb0-6a2ff99071c5",
            isBase: true,
            moleculeId: "b3b1a625-940a-48ee-9e8b-f16436ebba50",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "af920c37-2bcc-4fe7-9ebf-a9966111afcd",
            isBase: true,
            moleculeId: "96e5e03c-f74f-435e-876e-7b0f6691e5e1",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "9efe587d-de85-4b8e-9ca5-20353c747d56",
            isBase: true,
            moleculeId: "58bde22e-6714-414c-b6f4-e53881c0b3d1",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "51f1a279-8dfe-4fcb-97eb-a923a547a382",
            isBase: true,
            moleculeId: "59d730ae-cde9-40bb-ba40-7b2c10d13605",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
      ],
      groupId: "5960e13d-1a13-474a-80d9-3c39ed1e3953",
      isBase: true,
      moleculeId: "c7bdb179-5f99-4815-9555-8806d06e235f",
      options: {
        showHydrogen: true,
      },
      rangeId: "e8e0908a-4bc4-40eb-a042-1564137041fd-0",
      structure: "aromatic-ring-empty",
    },
  },
  elderberry: {
    ranges: {
      "b0c634bb-2042-4bfc-9768-0db153c2218e": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "5dd28b09-6a9e-48db-b135-f4c6c597be2e": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "2b55059d-ea7d-4ba3-9a06-65aa80cd4a06": {
        assigned: FUNCTIONAL_GROUPS[2],
      },
      "d8478728-bcbe-4420-a5cb-06b9d5a1e6b6": {
        assigned: FUNCTIONAL_GROUPS[3],
      },
      "0b648186-2986-477b-a14b-9593158363fb": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "44e3bd04-03b0-46e7-997c-0db5c72bd98d": {
        assigned: PROTON_TYPES[26],
        splitting: 3,
        hydrogens: 1,
      },
      "f5936421-312f-4e91-b4c6-3843fcfb1342": {
        assigned: PROTON_TYPES[8],
        splitting: 9,
        hydrogens: 5,
      },
      "86f67f66-05af-490b-aafd-15f66595a192": {
        assigned: PROTON_TYPES[9],
        splitting: 2,
        hydrogens: 2,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "3b00c391-e928-48f3-8063-341575d91c28",
                  isBase: true,
                  moleculeId: "df5dca4a-cbd7-4772-b1f7-2eb5f41a9a26",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "44e3bd04-03b0-46e7-997c-0db5c72bd98d-0",
                  structure: "aldehyde",
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "44aafb57-0c34-4a0a-95fc-e3401c41ac03",
            moleculeId: "052665d3-928a-4bb4-9385-f47bb020988b",
            options: {
              showHydrogen: true,
            },
            rangeId: "86f67f66-05af-490b-aafd-15f66595a192-0",
            structure: "ch2",
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "29231800-52c4-4dff-86b5-9601ac5d9483",
            isBase: true,
            moleculeId: "a9a162f5-0bee-424e-bbf6-696cab2f7130",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "184e3143-86ca-4e2d-8163-ead702262c04",
            isBase: true,
            moleculeId: "bdb8eae9-ecba-4d3f-9af4-21d26c1f0913",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "564f0cb7-ad23-413a-9dbb-e400e2eae97f",
            isBase: true,
            moleculeId: "e2e58511-a503-4f97-9471-fe7bb957442b",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "ba8ef00c-5e06-4915-8d1f-5cf32fdfbc9e",
            isBase: true,
            moleculeId: "7ebe057b-2f2d-468e-913f-30b1b1070dda",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "49203d29-b2cd-43ca-8f77-44e0769a6d14",
            isBase: true,
            moleculeId: "07903273-c0bf-47f8-a6ad-f43381986190",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
      ],
      groupId: "44aafb57-0c34-4a0a-95fc-e3401c41ac03",
      isBase: true,
      moleculeId: "31b1ef05-93eb-4bf2-8ed4-b96f75b0a20d",
      options: {
        showHydrogen: true,
      },
      rangeId: "86f67f66-05af-490b-aafd-15f66595a192-0",
      structure: "aromatic-ring-empty",
    },
  },
  cheese: {
    ranges: {
      "af60ac95-17ca-4f55-9571-0c0dce49e77b": {
        assigned: FUNCTIONAL_GROUPS[12],
      },
      "2df88e9c-4c9b-4824-9fa1-ea92516042fb": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "e589763c-0179-4a95-9aaf-98816f761ccb": {
        assigned: PROTON_TYPES[8],
        splitting: 2,
        hydrogens: 2,
      },
      "3129ceaa-1791-4824-b5d7-a9498522832c": {
        assigned: PROTON_TYPES[8],
        splitting: 2,
        hydrogens: 2,
      },
      "16371363-372f-4aab-b7f7-ef632b085ddf": {
        assigned: PROTON_TYPES[33],
        splitting: 3,
        hydrogens: 2,
      },
      "19bf3bd0-6009-4fed-b4b2-c576d31c3b03": {
        assigned: PROTON_TYPES[9],
        splitting: 3,
        hydrogens: 2,
      },
    },
  },
  "cinnamon-stick": {
    ranges: {
      "895c5175-7397-4316-9157-ef6e8686f94c": {
        assigned: FUNCTIONAL_GROUPS[4],
      },
      "e700d7aa-0b4d-4b02-871e-1004e8fb667d": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "b72c4f63-cfda-4a5a-a5ba-94684034abb3": {
        assigned: FUNCTIONAL_GROUPS[2],
      },
      "5c1b8367-9c3b-4e92-925c-958814a94aa5": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "89a73874-a4d3-4c6f-9198-d084bfe6d4b7": {
        assigned: FUNCTIONAL_GROUPS[5],
      },
      "cdca5937-2278-4d3a-bca2-7c3266f529bc": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "d5d9bca1-f302-411d-adb1-c0286997ea71": {
        assigned: PROTON_TYPES[26],
        splitting: 2,
        hydrogens: 1,
      },
      "e41bb380-1e72-4465-beee-1e75ec3334f0": {
        assigned: PROTON_TYPES[8],
        splitting: 5,
        hydrogens: 2,
      },
      "af663fa9-8a4a-4329-ab78-ff79d20cdd62": {
        assigned: PROTON_TYPES[8],
        splitting: 2,
        hydrogens: 1,
      },
      "df8d0618-478b-405c-ba07-ba7cbe9b7394": {
        assigned: PROTON_TYPES[8],
        splitting: 3,
        hydrogens: 3,
      },
      "3943d222-54f6-4f65-b395-9343948809d7": {
        assigned: PROTON_TYPES[3],
        splitting: 4,
        hydrogens: 1,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "0985dac5-bc90-447b-a7c9-150d569663f7",
                  isBase: true,
                  moleculeId: "42d70474-b42a-4caa-837d-ef882964380e",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "e700d7aa-0b4d-4b02-871e-1004e8fb667d-0",
                  structure: "aldehyde",
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "b9b6b600-570c-49bf-88cf-8d83022f9005",
                  isBase: true,
                  moleculeId: "a0eafe0d-4c65-4446-9e21-1f242055eb98",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r4",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "188a6d73-1f24-41e1-929f-247e52b5025d",
                  isBase: true,
                  moleculeId: "b277c67b-2c48-4d29-b756-587e8e1e0d3c",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "c81f12fc-64f3-4c88-a1e8-b9e2a63c8d00",
            isBase: true,
            moleculeId: "30c70b67-43cf-4fe6-aaa8-0146de99fc10",
            rangeId: "5c1b8367-9c3b-4e92-925c-958814a94aa5-0",
            structure: "alkene",
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "15df581d-b661-46e5-9322-f97741ad3930",
            isBase: true,
            moleculeId: "cbdb703c-5b6f-4e79-bf6d-9a5d82f6e4a2",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "f393ff7f-736d-414d-aca9-a1c6cbe6f628",
            isBase: true,
            moleculeId: "b955d6f3-177c-4f07-8840-9b720a55c99c",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "07418a7f-5377-442c-a1d2-96e7f287c22a",
            isBase: true,
            moleculeId: "50dfdbc4-2eff-40e2-a21d-0c7c25f1d9cf",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "8bb3313a-30a3-47b6-86bd-e9f1adb8f309",
            isBase: true,
            moleculeId: "dba631bd-e1db-450b-b0dc-a333f9786a29",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "70c4bfd2-6762-41d3-b005-e518a5e6aba4",
            isBase: true,
            moleculeId: "0c3c0bbd-6f40-4595-89ce-d4ecff136f5d",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
      ],
      groupId: "bb0e5e70-40ea-4c52-8e91-3afdab1b4201",
      isBase: true,
      moleculeId: "db885c7d-9bfa-4fc6-b607-9f1e02524d49",
      rangeId: "b72c4f63-cfda-4a5a-a5ba-94684034abb3-0",
      structure: "aromatic-ring-empty",
    },
  },
  raspberry: {
    ranges: {
      "248b7494-b447-425b-865b-ac8915523e21": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "9d23d6ba-7d27-4ba5-9f7b-73b8c7cf0ea6": {
        assigned: FUNCTIONAL_GROUPS[18],
      },
      "09415776-eea1-4ccd-b1b1-d55c403060d4": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "1da41bda-0371-4981-b10c-abaa15cdc67d": {
        assigned: PROTON_TYPES[18],
        splitting: 2,
        hydrogens: 2,
      },
      "94d20daa-8a3e-464e-b8a2-25a13688d7bd": {
        assigned: PROTON_TYPES[21],
        splitting: 1,
        hydrogens: 3,
      },
      "efbe10a1-c99d-4384-a7e0-328428073f14": {
        assigned: PROTON_TYPES[2],
        splitting: 9,
        hydrogens: 1,
      },
      "0d175904-4a89-4a4e-89a8-b265d2086365": {
        assigned: PROTON_TYPES[0],
        splitting: 2,
        hydrogens: 6,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "50bc29a3-49e5-4e4a-82de-0f99ffb36ed5",
                  isBase: true,
                  moleculeId: "217b8d31-8085-4d5b-ab30-95ae5f99e667",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r1",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "75c138e4-08fd-47a7-95f2-0ff39648f3d0",
                        isBase: true,
                        moleculeId: "96e37053-927b-4f4b-8e46-519725e57393",
                        options: {
                          label: ["c1", "h1", "h2", "h3"],
                        },
                        rangeId: "0d175904-4a89-4a4e-89a8-b265d2086365-0",
                        structure: "ch3",
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "e738622d-ed98-422d-bb58-121a4910c9f4",
                        isBase: true,
                        moleculeId: "e5dfa111-11e7-402c-815f-0a706ecd73c4",
                        options: {
                          label: ["c1", "h1", "h2", "h3"],
                        },
                        rangeId: "0d175904-4a89-4a4e-89a8-b265d2086365-0",
                        structure: "ch3",
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "34d4ded7-7f06-43aa-b86b-a35d23810d06",
                  isBase: true,
                  moleculeId: "513ca9b1-6aae-4314-a240-78ace1300a79",
                  options: {
                    label: ["c1"],
                    showHydrogen: true,
                  },
                  rangeId: "248b7494-b447-425b-865b-ac8915523e21-0",
                  structure: "ch",
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "6235b119-e980-41c9-aead-644bcd30ceb5",
            moleculeId: "b660fae3-2594-49eb-a8cd-fc4f3b6164c0",
            options: {
              showHydrogen: true,
            },
            rangeId: "1da41bda-0371-4981-b10c-abaa15cdc67d-0",
            structure: "ch",
          },
          parentAtom: "r2",
          sourceAtom: "r2",
        },
        {
          molecule: {
            groupId: "11812a28-a3df-4714-8d56-7a5d5adfcaf5",
            isBase: true,
            moleculeId: "b871158c-b5a5-4549-85e3-862a390358c6",
            options: {
              label: ["c1", "h1", "h2", "h3"],
            },
            rangeId: "0d175904-4a89-4a4e-89a8-b265d2086365-0",
            structure: "ch3",
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
      ],
      groupId: "6235b119-e980-41c9-aead-644bcd30ceb5",
      isBase: true,
      moleculeId: "b51158ba-37a8-4ac2-aa32-ef5caaf22dfc",
      options: {
        showHydrogen: true,
      },
      rangeId: "1da41bda-0371-4981-b10c-abaa15cdc67d-0",
      structure: "ester",
    },
  },
  pastry: {
    ranges: {
      "974f95c4-9c2b-4a59-b200-66c6398ae495": {
        assigned: FUNCTIONAL_GROUPS[12],
      },
      "4008a684-b43f-478b-b535-43956f4ef308": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "2beff3d2-eee6-476f-848f-74e28ec26e72": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "ef038376-6af2-424e-a599-012f8fc0ced5": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "ed9985c0-275a-444a-aa2c-6f014cd5c8fe": {
        assigned: PROTON_TYPES[27],
        splitting: 1,
        hydrogens: 2,
      },
      "30214d50-6e36-4781-858f-dfba46f741a8": {
        assigned: PROTON_TYPES[18],
        splitting: 4,
        hydrogens: 2,
      },
      "4847a788-6c01-4049-a7ab-f350527204a6": {
        assigned: PROTON_TYPES[0],
        splitting: 3,
        hydrogens: 3,
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "e6e2ecdd-e92a-482a-bf06-b7235156bf11",
                        isBase: true,
                        moleculeId: "1795f8c9-7b56-4c08-ba36-c540d2c70825",
                        options: {
                          label: ["c1", "h1", "h2", "h3"],
                        },
                        rangeId: "4847a788-6c01-4049-a7ab-f350527204a6-0",
                        structure: "ch3",
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "1c88b725-906e-41f2-a852-8d1e81735b47",
                        isBase: true,
                        moleculeId: "d76f7094-4583-4dfd-b4fa-195117873552",
                        rangeId: "default",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r1",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "d8a4e2ea-334f-4cd7-997a-e1f0fbfce1e8",
                  moleculeId: "e781e7cd-f05e-4877-a5d5-87a549b7fd0e",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "30214d50-6e36-4781-858f-dfba46f741a8-0",
                  structure: "ch",
                },
                parentAtom: "r1",
                sourceAtom: "r2",
              },
            ],
            groupId: "d8a4e2ea-334f-4cd7-997a-e1f0fbfce1e8",
            isBase: true,
            moleculeId: "b202d4a1-da1b-4be3-82b4-18dbd4b3b1fe",
            options: {
              showHydrogen: true,
            },
            rangeId: "30214d50-6e36-4781-858f-dfba46f741a8-0",
            structure: "oxygen",
          },
          parentAtom: "r1",
          sourceAtom: "r2",
        },
        {
          molecule: {
            groupId: "455ddfd4-d225-4a45-a7cd-7b5639045638",
            isBase: true,
            moleculeId: "cdfb84aa-7a39-43a4-b75d-f999f3eb5808",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
      ],
      groupId: "c37090ac-5663-4468-b3c1-d99c94d4871a",
      isBase: true,
      moleculeId: "4e808589-a62c-4379-a63f-1f44322cabfb",
      options: {
        showHydrogen: true,
      },
      rangeId: "ed9985c0-275a-444a-aa2c-6f014cd5c8fe-0",
      structure: "amide",
    },
  },
  anise: {
    ranges: {
      "9782f09f-bbc0-4251-80f9-c804844a593c": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "4708710f-cf7e-4905-a017-f0a75e5c1800": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "cea265b5-5352-44dd-b466-946ed3f717c0": {
        assigned: FUNCTIONAL_GROUPS[2],
      },
      "1df8f9d1-5ff4-49c0-b815-380f925ee441": {
        assigned: FUNCTIONAL_GROUPS[3],
      },
      "f2e508a2-70e8-49d7-af89-b3a2695dd5fb": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "4b5032aa-2738-429e-baca-9ac458495899": {
        assigned: PROTON_TYPES[26],
        splitting: 1,
        hydrogens: 1,
      },
      "44f844ef-db45-4f07-a8c7-d475e28eedd3": {
        assigned: PROTON_TYPES[8],
        splitting: 2,
        hydrogens: 2,
      },
      "ff843e5d-10a6-489e-97f9-ba1ebef74201": {
        assigned: PROTON_TYPES[8],
        splitting: 2,
        hydrogens: 2,
      },
      "a6ff71b5-eae4-4618-926d-6c2c3fae96ed": {
        assigned: PROTON_TYPES[18],
        splitting: 1,
        hydrogens: 3,
      },
    },
    build: {
      rangeId: "abc",
      structure: "aromatic-ring",
      assign: [
        {
          parentAtom: "h3",
          sourceAtom: "r1",
          molecule: {
            rangeId: "def",
            structure: "aldehyde",
          },
        },
        {
          parentAtom: "h6",
          sourceAtom: "r1",
          molecule: {
            rangeId: "123",
            structure: "ether",
            assign: [
              {
                parentAtom: "r2",
                sourceAtom: "r1",
                molecule: {
                  structure: "ch3",
                },
              },
            ],
          },
        },
      ],
    },
  },
  apple: {
    ranges: {
      "a5738698-2e04-404d-9f0b-844ccfc6ac6c": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "83399e09-1206-4d4a-9a47-978132acfacd": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "87259e85-784c-4d3a-a384-d6fb6c160154": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "3265760d-0d30-477a-a6b7-619ec401eb69": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "9a4f664a-c7da-4703-8593-127228d4e5b3": {
        assigned: PROTON_TYPES[8],
        splitting: 2,
        hydrogens: 2,
      },
      "cd6f0214-368b-4f04-a7e4-eecadd059724": {
        assigned: PROTON_TYPES[8],
        splitting: 3,
        hydrogens: 1,
      },
      "c5c9508a-aacb-48ba-af09-cf9c329e9c9e": {
        assigned: PROTON_TYPES[8],
        splitting: 3,
        hydrogens: 2,
      },
      "e4208c1c-e356-4d09-abdb-a5dc9bdf4d21": {
        assigned: PROTON_TYPES[24],
        splitting: 1,
        hydrogens: 3,
      },
    },
    build: {
      rangeId: "abc",
      structure: "aromatic-ring",
      assign: [
        {
          parentAtom: "h3",
          sourceAtom: "r1",
          molecule: {
            structure: "ketone",
            assign: [
              {
                parentAtom: "r2",
                sourceAtom: "r1",
                molecule: {
                  structure: "ch3",
                },
              },
            ],
          },
        },
      ],
    },
  },
  banana: {
    ranges: {
      "909c49fd-6457-4c44-a705-9bf9703958b1": {
        assigned: FUNCTIONAL_GROUPS[0],
      },
      "a4bcb866-5afb-4733-9bd5-3674c5215e0a": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "edec0c2a-fcf7-43b5-8dea-e34ad332a402": {
        splitting: 3,
        assigned: PROTON_TYPES[31],
        hydrogens: 2,
      },
      "73526b5e-328b-41f1-a5ad-1944d6a5054e": {
        splitting: 9,
        assigned: PROTON_TYPES[2],
        hydrogens: 1,
      },
      "d46f44d2-b3c0-490b-8c92-0e81e2646fa3": {
        splitting: 4,
        assigned: PROTON_TYPES[1],
        hydrogens: 2,
      },
      "145b597e-4e0c-4b5a-8ced-b6654084cbe5": {
        splitting: 1,
        assigned: PROTON_TYPES[30],
        hydrogens: 1,
      },
      "b7eeb195-5eb1-4b36-b023-2b12e31373c1": {
        splitting: 2,
        assigned: PROTON_TYPES[0],
        hydrogens: 6,
      },
    },
    build: {
      rangeId: "abc",
      structure: "ch",
      assign: [
        {
          parentAtom: "r1",
          sourceAtom: "r1",
          molecule: {
            structure: "ch3",
          },
        },
        {
          parentAtom: "r3",
          sourceAtom: "r1",
          molecule: {
            structure: "ch3",
          },
        },
        {
          parentAtom: "r2",
          sourceAtom: "r1",
          molecule: {
            structure: "ch2",
            assign: [
              {
                parentAtom: "r2",
                sourceAtom: "r1",
                molecule: {
                  structure: "ch2",
                  assign: [
                    {
                      parentAtom: "r2",
                      sourceAtom: "r1",
                      molecule: {
                        structure: "oxygen",
                        assign: [
                          {
                            parentAtom: "r2",
                            sourceAtom: "r1",
                            molecule: {
                              structure: "hydrogen",
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  strawberry: {
    ranges: {
      "75ed7bd0-d045-4d8d-b088-029e88ac02dc": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "9fa60024-5b23-47f8-b69a-4b3fa3bb6e50": {
        assigned: FUNCTIONAL_GROUPS[2],
      },
      "627a2da5-27f0-410e-8acd-e019fb7619b8": {
        assigned: FUNCTIONAL_GROUPS[3],
      },
      "0591c5c1-1e57-408f-ae3e-3b45eb6930f0": {
        splitting: 1,
        assigned: PROTON_TYPES[26],
        hydrogens: 1,
      },
      "dd604113-0e9a-4ab8-b72c-d47e7e0dbb00": {
        splitting: 3,
        assigned: PROTON_TYPES[24], //R-CO-CH-
        hydrogens: 2,
      },
      "97e69902-0dbf-47ca-bc53-5fce3142400f": {
        splitting: 6,
        assigned: PROTON_TYPES[1], //R2-CH2
        hydrogens: 2,
      },
      "d82429bb-a12a-432d-8315-dd06ee5ca23d": {
        splitting: 3,
        assigned: PROTON_TYPES[0], //R-CH3
        hydrogens: 3,
      },
    },
    build: {
      structure: "ch3",
      assign: [
        {
          parentAtom: "r1",
          sourceAtom: "r1",
          molecule: {
            structure: "ch2",
            assign: [
              {
                parentAtom: "r2",
                sourceAtom: "r1",
                molecule: {
                  structure: "ch2",
                  assign: [
                    {
                      parentAtom: "r2",
                      sourceAtom: "r1",
                      molecule: {
                        structure: "aldehyde",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  pineapple: {
    ranges: {
      "8159709c-b311-4b2e-831f-7d5f26f5905a": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "ca2ee8c1-f73f-41d4-810c-7ec03bbb17bb": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "005530ea-22cd-457a-9344-71d14d8d6ca5": {
        splitting: 3,
        hydrogens: 2,
        assigned: PROTON_TYPES[24],
      },
      "8080475f-40e9-46f9-9a68-36f9e4a037a0": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[24],
      },
      "a245b971-fd42-4d61-8c5c-21cbc74fd993": {
        splitting: 6,
        hydrogens: 2,
        assigned: PROTON_TYPES[1],
      },
      "e640b66c-5a67-4d01-8759-6293bc6b6198": {
        splitting: 3,
        hydrogens: 3,
        assigned: PROTON_TYPES[0],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "ef545d7a-c97f-4e52-a67f-c125017ecb81",
                  isBase: true,
                  moleculeId: "2011dd6a-ee0d-469c-bf7a-67b1848df968",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r1",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "0d3bdb06-e13b-426e-a58e-a90dee4a8dc3",
                  isBase: true,
                  moleculeId: "62eb629b-cd57-45a9-92d7-033a9e41930f",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "f8bd96d3-56e6-4e4f-8261-8d9d0675059b",
            moleculeId: "7ffe85c5-84b3-4bb6-9f5e-b1f4d6534636",
            options: {
              showHydrogen: true,
            },
            rangeId: "8080475f-40e9-46f9-9a68-36f9e4a037a0-0",
            structure: "ch",
          },
          parentAtom: "r1",
          sourceAtom: "r2",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "0406a8e7-f2f9-4280-81b6-19ffb719473e",
                        isBase: true,
                        moleculeId: "3cf313fe-cb51-4e48-9f8a-a5089a860921",
                        options: {
                          label: ["c1", "h1", "h2", "h3"],
                        },
                        rangeId: "e640b66c-5a67-4d01-8759-6293bc6b6198-0",
                        structure: "ch3",
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "36116e82-0161-4f9d-af82-24f8b83838f0",
                  isBase: true,
                  moleculeId: "d59603cb-8d26-48c5-b4b8-cc062284589b",
                  options: {
                    label: ["c1", "h1", "h2"],
                    showHydrogen: true,
                  },
                  rangeId: "a245b971-fd42-4d61-8c5c-21cbc74fd993-0",
                  structure: "ch2",
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "70380844-e71e-4d90-ab85-70cb3a98de4e",
            isBase: true,
            moleculeId: "74075ece-24f4-4396-9d49-53480edf6a4a",
            options: {
              label: ["c1", "h1", "h2"],
              showHydrogen: true,
            },
            rangeId: "a245b971-fd42-4d61-8c5c-21cbc74fd993-0",
            structure: "ch2",
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
      ],
      groupId: "f8bd96d3-56e6-4e4f-8261-8d9d0675059b",
      isBase: true,
      moleculeId: "a297d327-bb09-4b5f-b575-e59875468366",
      options: {
        showHydrogen: true,
      },
      rangeId: "8080475f-40e9-46f9-9a68-36f9e4a037a0-0",
      structure: "ketone",
    },
  },
  cranberry: {
    ranges: {
      "b62245b7-2f3d-4be8-90ee-4b9262c898bd": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "8fdc3c78-8e00-4add-93e5-41143585e865": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "13a53fd8-3b49-4ffe-b340-987a07e8065c": {
        assigned: FUNCTIONAL_GROUPS[18],
      },
      "c852cacb-c9f4-4bab-9cb3-c2ddc8665ea4": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "3b114ed9-4e0f-4ded-abf4-9e3c118614d7": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "5013a15e-ba5d-451c-b4d7-430c21d26a4b": {
        splitting: 1,
        hydrogens: 1,
        assigned: PROTON_TYPES[26],
      },
      "84bcf407-0d30-49e1-8aa9-1533131aa685": {
        splitting: 3,
        hydrogens: 5,
        assigned: PROTON_TYPES[8],
      },
      "ad5e5878-730c-452a-9e40-a7fe43bf6675": {
        splitting: 1,
        hydrogens: 2,
        assigned: PROTON_TYPES[10],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "c0e07356-b062-4c41-a635-6919ffa94de8",
                        isBase: true,
                        moleculeId: "3972fc91-f4a2-4a31-ac94-7bc28dc5e20a",
                        rangeId: "undefined-0",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r1",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "6009cdb2-2351-4942-bfb5-f300006abe3f",
                  moleculeId: "ed4b3083-fd54-47a8-a0f5-8291eb5487f2",
                  rangeId: "ad5e5878-730c-452a-9e40-a7fe43bf6675-0",
                  structure: "ester",
                },
                parentAtom: "r2",
                sourceAtom: "r2",
              },
            ],
            groupId: "6009cdb2-2351-4942-bfb5-f300006abe3f",
            moleculeId: "e034e1c8-c52a-41a4-9c9c-b7b20af9fc4e",
            options: {
              showHydrogen: true,
            },
            rangeId: "ad5e5878-730c-452a-9e40-a7fe43bf6675-0",
            structure: "ch2",
          },
          parentAtom: "h3",
          sourceAtom: "r1",
        },
      ],
      groupId: "6009cdb2-2351-4942-bfb5-f300006abe3f",
      isBase: true,
      moleculeId: "90451a59-e84b-4dd1-a89a-e6ec91984f4b",
      options: {
        showHydrogen: true,
      },
      rangeId: "ad5e5878-730c-452a-9e40-a7fe43bf6675-0",
      structure: "aromatic-ring",
    },
  },
  coffee: {
    ranges: {
      "c04bf2e9-03b7-4f74-8cbe-e9efb3fbb926": {
        assigned: FUNCTIONAL_GROUPS[4],
      },
      "342f15c0-bffc-40b4-a6f0-e79eabe13dcf": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "aa13d640-d6e4-437c-99db-acca152cc1d5": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "b8dfc72b-08ef-4abd-b3a2-c1fd16f2f93b": {
        splitting: 22,
        hydrogens: 1,
        assigned: PROTON_TYPES[40],
      },
      "29d837fa-249f-4055-940c-4feb0633b9b7": {
        splitting: 9,
        hydrogens: 1,
        assigned: PROTON_TYPES[40],
      },
      "a682f83e-0813-42ab-8e1b-104202c3b77e": {
        splitting: 22,
        hydrogens: 1,
        assigned: PROTON_TYPES[40],
      },
      "95e7aed3-bbcf-4a6b-acf9-84718f397d40": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[39],
      },
      "3b13f09e-cc56-4df9-84cb-14e1fca4cce2": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[24],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            groupId: "e454f979-e52e-46ee-94e0-cfe9dc383e0a",
            moleculeId: "b5fa8488-8181-44dc-97dd-eca8a32647df",
            options: {
              showHydrogen: true,
            },
            rangeId: "a682f83e-0813-42ab-8e1b-104202c3b77e-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "h2",
                  name: "H",
                },
                {
                  id: "h3",
                  name: "H",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-h2",
                  source: "c1",
                  target: "h2",
                  type: 1,
                },
                {
                  id: "c1-h3",
                  source: "c1",
                  target: "h3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "e454f979-e52e-46ee-94e0-cfe9dc383e0a",
            moleculeId: "cc68b029-bf3d-4e5a-88c7-242cd9c25cc1",
            options: {
              showHydrogen: true,
            },
            rangeId: "a682f83e-0813-42ab-8e1b-104202c3b77e-0",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "e454f979-e52e-46ee-94e0-cfe9dc383e0a",
            moleculeId: "f0e96fea-a93d-472c-a1e0-5117eaf2a103",
            options: {
              showHydrogen: true,
            },
            rangeId: "a682f83e-0813-42ab-8e1b-104202c3b77e-0",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "514e16fb-6b8b-47f4-bf6a-1edc13f3b8b0",
                        isBase: true,
                        moleculeId: "77122018-2706-47d4-a836-34af719f0a55",
                        rangeId: "default",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "93731896-abd5-4a42-864e-b3bc27387bcf",
                        isBase: true,
                        moleculeId: "680c8d25-21e5-4ad2-bdb4-9f67c773cff5",
                        rangeId: "default",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "91ef3895-75b7-4f20-8ba8-4afe313f9aa7",
                  isBase: true,
                  moleculeId: "6bb69a99-a1e5-46d5-98cb-02acbfb74f89",
                  options: {
                    label: ["c1"],
                    showHydrogen: true,
                  },
                  rangeId: "342f15c0-bffc-40b4-a6f0-e79eabe13dcf-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "r2",
                        name: "R",
                      },
                      {
                        id: "r3",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-r2",
                        source: "c1",
                        target: "r2",
                        type: 1,
                      },
                      {
                        id: "c1-r3",
                        source: "c1",
                        target: "r3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "5c12854d-5457-476d-96c7-6c1505381043",
            isBase: true,
            moleculeId: "0d9036e2-bdf3-4eeb-84ee-95459fb920bb",
            rangeId: "aa13d640-d6e4-437c-99db-acca152cc1d5-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "o1",
                  name: "O",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "r2",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-o1",
                  source: "c1",
                  target: "o1",
                  type: 2,
                },
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "9781ee7b-8527-4672-9e67-0b9bee51b8d2",
            isBase: true,
            moleculeId: "0e455ec8-f5aa-433d-8c8b-e284d634e9c1",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
      ],
      groupId: "e454f979-e52e-46ee-94e0-cfe9dc383e0a",
      isBase: true,
      moleculeId: "8319030c-bd3e-4759-9f8b-834e68e353b9",
      options: {
        showHydrogen: true,
      },
      rangeId: "a682f83e-0813-42ab-8e1b-104202c3b77e-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "c2",
            name: "C",
          },
          {
            id: "c3",
            name: "C",
          },
          {
            id: "c4",
            name: "C",
          },
          {
            id: "n1",
            name: "N",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
          {
            id: "r3",
            name: "R",
          },
          {
            id: "r4",
            name: "R",
          },
          {
            id: "r5",
            name: "R",
          },
          {
            id: "p1",
            name: "",
          },
          {
            id: "p2",
            name: "",
          },
          {
            id: "p3",
            name: "",
          },
          {
            id: "p4",
            name: "",
          },
          {
            id: "p5",
            name: "",
          },
          {
            id: "p6",
            name: "",
          },
          {
            id: "p7",
            name: "",
          },
          {
            id: "p8",
            name: "",
          },
          {
            id: "p9",
            name: "",
          },
          {
            id: "p10",
            name: "",
          },
          {
            id: "p11",
            name: "",
          },
          {
            id: "p12",
            name: "",
          },
          {
            id: "p13",
            name: "",
          },
          {
            id: "p14",
            name: "",
          },
          {
            id: "p15",
            name: "",
          },
          {
            id: "p16",
            name: "",
          },
          {
            id: "p17",
            name: "",
          },
          {
            id: "p18",
            name: "",
          },
          {
            id: "p19",
            name: "",
          },
          {
            id: "p20",
            name: "",
          },
          {
            id: "p21",
            name: "",
          },
          {
            id: "p22",
            name: "",
          },
          {
            id: "p23",
            name: "",
          },
          {
            id: "p24",
            name: "",
          },
          {
            id: "p25",
            name: "",
          },
          {
            id: "p26",
            name: "",
          },
          {
            id: "p27",
            name: "",
          },
          {
            id: "p28",
            name: "",
          },
          {
            id: "p29",
            name: "",
          },
          {
            id: "p30",
            name: "",
          },
          {
            id: "p31",
            name: "",
          },
          {
            id: "p32",
            name: "",
          },
          {
            id: "p33",
            name: "",
          },
          {
            id: "p34",
            name: "",
          },
          {
            id: "p35",
            name: "",
          },
          {
            id: "p36",
            name: "",
          },
          {
            id: "p37",
            name: "",
          },
          {
            id: "p38",
            name: "",
          },
          {
            id: "p39",
            name: "",
          },
          {
            id: "p40",
            name: "",
          },
          {
            id: "p41",
            name: "",
          },
          {
            id: "p42",
            name: "",
          },
          {
            id: "p43",
            name: "",
          },
          {
            id: "p44",
            name: "",
          },
          {
            id: "p45",
            name: "",
          },
          {
            id: "p46",
            name: "",
          },
          {
            id: "p47",
            name: "",
          },
          {
            id: "p48",
            name: "",
          },
          {
            id: "p49",
            name: "",
          },
          {
            id: "p50",
            name: "",
          },
          {
            id: "p51",
            name: "",
          },
          {
            id: "p52",
            name: "",
          },
          {
            id: "p53",
            name: "",
          },
          {
            id: "p54",
            name: "",
          },
          {
            id: "p55",
            name: "",
          },
          {
            id: "p56",
            name: "",
          },
          {
            id: "p57",
            name: "",
          },
          {
            id: "p58",
            name: "",
          },
          {
            id: "p59",
            name: "",
          },
          {
            id: "p60",
            name: "",
          },
          {
            id: "p61",
            name: "",
          },
          {
            id: "p62",
            name: "",
          },
          {
            id: "p63",
            name: "",
          },
          {
            id: "p64",
            name: "",
          },
          {
            id: "p65",
            name: "",
          },
          {
            id: "p66",
            name: "",
          },
          {
            id: "p67",
            name: "",
          },
          {
            id: "p68",
            name: "",
          },
          {
            id: "p69",
            name: "",
          },
          {
            id: "p70",
            name: "",
          },
          {
            id: "p71",
            name: "",
          },
        ],
        bonds: [
          {
            id: "n1-p1",
            source: "n1",
            target: "p1",
            type: 0,
          },
          {
            id: "n1-p2",
            source: "n1",
            target: "p2",
            type: 0,
          },
          {
            id: "n1-p3",
            source: "n1",
            target: "p3",
            type: 0,
          },
          {
            id: "n1-p62",
            source: "n1",
            target: "p62",
            type: 0,
          },
          {
            id: "n1-p63",
            source: "n1",
            target: "p63",
            type: 0,
          },
          {
            id: "n1-r5",
            source: "n1",
            target: "r5",
            type: 1,
          },
          {
            id: "n1-p64",
            source: "n1",
            target: "p64",
            type: 0,
          },
          {
            id: "n1-p65",
            source: "n1",
            target: "p65",
            type: 0,
          },
          {
            id: "n1-p66",
            source: "n1",
            target: "p66",
            type: 0,
          },
          {
            id: "n1-p67",
            source: "n1",
            target: "p67",
            type: 0,
          },
          {
            id: "n1-p68",
            source: "n1",
            target: "p68",
            type: 0,
          },
          {
            id: "n1-c1",
            multiplier: 2,
            source: "n1",
            target: "c1",
            type: 1,
          },
          {
            id: "n1-p4",
            source: "n1",
            target: "p5",
            type: 0,
          },
          {
            id: "n1-p69",
            source: "n1",
            target: "p69",
            type: 0,
          },
          {
            id: "n1-p70",
            source: "n1",
            target: "p70",
            type: 0,
          },
          {
            id: "n1-p71",
            source: "n1",
            target: "p71",
            type: 0,
          },
          {
            id: "c1-p6",
            source: "c1",
            target: "p6",
            type: 0,
          },
          {
            id: "c1-p7",
            source: "c1",
            target: "p7",
            type: 0,
          },
          {
            id: "c1-p8",
            source: "c1",
            target: "p8",
            type: 0,
          },
          {
            id: "c1-p9",
            source: "c1",
            target: "p9",
            type: 0,
          },
          {
            id: "c1-p10",
            source: "c1",
            target: "p10",
            type: 0,
          },
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "c1-p11",
            source: "c1",
            target: "p11",
            type: 0,
          },
          {
            id: "c1-p12",
            source: "c1",
            target: "p12",
            type: 0,
          },
          {
            id: "c1-p13",
            source: "c1",
            target: "p13",
            type: 0,
          },
          {
            id: "c1-p14",
            source: "c1",
            target: "p14",
            type: 0,
          },
          {
            id: "c1-p15",
            source: "c1",
            target: "p15",
            type: 0,
          },
          {
            id: "c1-c2",
            source: "c1",
            target: "c2",
            type: 2,
          },
          {
            id: "c1-p16",
            source: "c1",
            target: "p16",
            type: 0,
          },
          {
            id: "c1-p17",
            source: "c1",
            target: "p17",
            type: 0,
          },
          {
            id: "c1-p18",
            source: "c1",
            target: "p18",
            type: 0,
          },
          {
            id: "c1-p19",
            source: "c1",
            target: "p19",
            type: 0,
          },
          {
            id: "c2-p20",
            source: "c2",
            target: "p20",
            type: 0,
          },
          {
            id: "c2-p21",
            source: "c2",
            target: "p21",
            type: 0,
          },
          {
            id: "c2-p22",
            source: "c2",
            target: "p22",
            type: 0,
          },
          {
            id: "c2-p23",
            source: "c2",
            target: "p23",
            type: 0,
          },
          {
            id: "c2-p24",
            source: "c2",
            target: "p24",
            type: 0,
          },
          {
            id: "c2-r2",
            source: "c2",
            target: "r2",
            type: 1,
          },
          {
            id: "c2-p25",
            source: "c2",
            target: "p25",
            type: 0,
          },
          {
            id: "c2-p26",
            source: "c2",
            target: "p26",
            type: 0,
          },
          {
            id: "c2-p27",
            source: "c2",
            target: "p27",
            type: 0,
          },
          {
            id: "c2-p28",
            source: "c2",
            target: "p28",
            type: 0,
          },
          {
            id: "c2-p29",
            source: "c2",
            target: "p29",
            type: 0,
          },
          {
            id: "c2-c3",
            source: "c2",
            target: "c3",
            type: 1,
          },
          {
            id: "c2-p30",
            source: "c2",
            target: "p30",
            type: 0,
          },
          {
            id: "c2-p31",
            source: "c2",
            target: "p31",
            type: 0,
          },
          {
            id: "c2-p32",
            source: "c2",
            target: "p32",
            type: 0,
          },
          {
            id: "c2-p33",
            source: "c2",
            target: "p33",
            type: 0,
          },
          {
            id: "c3-p34",
            source: "c3",
            target: "p34",
            type: 0,
          },
          {
            id: "c3-p35",
            source: "c3",
            target: "p35",
            type: 0,
          },
          {
            id: "c3-p36",
            source: "c3",
            target: "p36",
            type: 0,
          },
          {
            id: "c3-p37",
            source: "c3",
            target: "p37",
            type: 0,
          },
          {
            id: "c3-p38",
            source: "c3",
            target: "p38",
            type: 0,
          },
          {
            id: "c3-r3",
            source: "c3",
            target: "r3",
            type: 1,
          },
          {
            id: "c3-p39",
            source: "c3",
            target: "p39",
            type: 0,
          },
          {
            id: "c3-p40",
            source: "c3",
            target: "p40",
            type: 0,
          },
          {
            id: "c3-p41",
            source: "c3",
            target: "p41",
            type: 0,
          },
          {
            id: "c3-p42",
            source: "c3",
            target: "p42",
            type: 0,
          },
          {
            id: "c3-p43",
            source: "c3",
            target: "p43",
            type: 0,
          },
          {
            id: "c3-c4",
            source: "c3",
            target: "c4",
            type: 2,
          },
          {
            id: "c3-p44",
            source: "c3",
            target: "p44",
            type: 0,
          },
          {
            id: "c3-p45",
            source: "c3",
            target: "p45",
            type: 0,
          },
          {
            id: "c3-p46",
            source: "c3",
            target: "p46",
            type: 0,
          },
          {
            id: "c3-p47",
            source: "c3",
            target: "p47",
            type: 0,
          },
          {
            id: "c4-p48",
            source: "c4",
            target: "p48",
            type: 0,
          },
          {
            id: "c4-p49",
            source: "c4",
            target: "p49",
            type: 0,
          },
          {
            id: "c4-p50",
            source: "c4",
            target: "p50",
            type: 0,
          },
          {
            id: "c4-p51",
            source: "c4",
            target: "p51",
            type: 0,
          },
          {
            id: "c4-p52",
            source: "c4",
            target: "p52",
            type: 0,
          },
          {
            id: "c4-r4",
            source: "c4",
            target: "r4",
            type: 1,
          },
          {
            id: "c4-p53",
            source: "c4",
            target: "p53",
            type: 0,
          },
          {
            id: "c4-p54",
            source: "c4",
            target: "p54",
            type: 0,
          },
          {
            id: "c4-p55",
            source: "c4",
            target: "p55",
            type: 0,
          },
          {
            id: "c4-p56",
            source: "c4",
            target: "p56",
            type: 0,
          },
          {
            id: "c4-p57",
            source: "c4",
            target: "p57",
            type: 0,
          },
          {
            id: "c4-n1",
            multiplier: 2,
            source: "c4",
            target: "n1",
            type: 1,
          },
          {
            id: "c4-p58",
            source: "c4",
            target: "p58",
            type: 0,
          },
          {
            id: "c4-p59",
            source: "c4",
            target: "p59",
            type: 0,
          },
          {
            id: "c4-p60",
            source: "c4",
            target: "p60",
            type: 0,
          },
          {
            id: "c4-p61",
            source: "c4",
            target: "p61",
            type: 0,
          },
        ],
      },
    },
  },
  "cooked-chicken": {
    ranges: {
      "715fd5c4-05b3-4f58-94ae-2a22eddf786f": {
        assigned: FUNCTIONAL_GROUPS[4],
      },
      "a893ed53-814d-4da6-8f2f-bbff66151164": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "17370419-b0d5-4942-9b1e-9e8275e9db10": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "f3e9f489-16b1-4404-922a-4b6bcafcef52": {
        assigned: FUNCTIONAL_GROUPS[5],
      },
      "a85f60c2-01bd-4165-978b-d14ab9708fa7": {
        splitting: 24,
        hydrogens: 1,
        assigned: PROTON_TYPES[3],
      },
      "5b791be6-9c21-437f-be88-0a7ee78f709b": {
        splitting: 24,
        hydrogens: 1,
        assigned: PROTON_TYPES[3],
      },
      "cebab8ef-4136-429c-acaf-ee4b704ef413": {
        splitting: 4,
        hydrogens: 2,
        assigned: PROTON_TYPES[24],
      },
      "dccd9e13-e051-4412-8827-3dfb140ac67f": {
        splitting: 22,
        hydrogens: 3,
        assigned: PROTON_TYPES[5],
      },
      "77c94901-d166-450d-b3be-2d60b44b81e5": {
        splitting: 3,
        hydrogens: 3,
        assigned: PROTON_TYPES[0],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "552c3a43-46d0-4cd3-a9c7-4983c8a75b32",
                  isBase: true,
                  moleculeId: "c1df297b-c773-4c39-8e6a-c6a844ba4aaa",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "a0dbee98-28bc-4868-a230-9bdb6381da3a",
                  isBase: true,
                  moleculeId: "b61f5320-8e3e-46b9-8759-8d706075157f",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "77c94901-d166-450d-b3be-2d60b44b81e5-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "h2",
                        name: "H",
                      },
                      {
                        id: "h3",
                        name: "H",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-h2",
                        source: "c1",
                        target: "h2",
                        type: 1,
                      },
                      {
                        id: "c1-h3",
                        source: "c1",
                        target: "h3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r1",
                sourceAtom: "r1",
              },
            ],
            groupId: "294c4097-fe01-4998-813d-d760d051e0b0",
            moleculeId: "e2b5d61e-018a-4d4e-be6c-80a7d0a852d3",
            options: {
              showHydrogen: true,
            },
            rangeId: "cebab8ef-4136-429c-acaf-ee4b704ef413-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r2",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "fd1cd2c7-dd83-48df-b15d-91ac4ca361da",
                  moleculeId: "bbc55f0d-53ed-486c-bed7-e26162fb9926",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "dccd9e13-e051-4412-8827-3dfb140ac67f-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "h2",
                        name: "H",
                      },
                      {
                        id: "h3",
                        name: "H",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-h2",
                        source: "c1",
                        target: "h2",
                        type: 1,
                      },
                      {
                        id: "c1-h3",
                        source: "c1",
                        target: "h3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "d09526b4-7949-4eac-a8ff-06404f54eab8",
                  isBase: true,
                  moleculeId: "472ac1df-3360-46f7-a4d3-e7a93745153d",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r4",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "9c826f78-611d-4246-9a57-46e6e60fcd33",
                  isBase: true,
                  moleculeId: "d6efc30e-510a-4a7f-9a29-d314e1fdb4a0",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "fd1cd2c7-dd83-48df-b15d-91ac4ca361da",
            isBase: true,
            moleculeId: "47d2b54a-87f5-4534-929a-066a41b8fe2a",
            options: {
              showHydrogen: true,
            },
            rangeId: "dccd9e13-e051-4412-8827-3dfb140ac67f-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "c2",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
                {
                  id: "r4",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-c2",
                  source: "c1",
                  target: "c2",
                  type: 2,
                },
                {
                  id: "c2-r3",
                  source: "c2",
                  target: "r3",
                  type: 1,
                },
                {
                  id: "c2-r4",
                  source: "c2",
                  target: "r4",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
      ],
      groupId: "294c4097-fe01-4998-813d-d760d051e0b0",
      isBase: true,
      moleculeId: "33512471-2cb2-466b-a1cb-3f978f7ab7d8",
      options: {
        showHydrogen: true,
      },
      rangeId: "cebab8ef-4136-429c-acaf-ee4b704ef413-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "o1",
            name: "O",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
        ],
        bonds: [
          {
            id: "c1-o1",
            source: "c1",
            target: "o1",
            type: 2,
          },
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "c1-r2",
            source: "c1",
            target: "r2",
            type: 1,
          },
        ],
      },
    },
  },
  cumin: {
    ranges: {
      "35e3ee2f-e418-489a-841c-ee0ff17ee0ce": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "14c1b284-4e00-4844-8ca4-b81592b3ea67": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "145c8b41-dc78-4f74-9dfb-70a021b5dbac": {
        assigned: FUNCTIONAL_GROUPS[2],
      },
      "b8f63caf-e254-497d-a770-69028ffa8148": {
        assigned: FUNCTIONAL_GROUPS[3],
      },
      "20b9a816-3155-4584-91df-18b48e7e394f": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "da4496ef-ad12-4540-b5ed-2d06efd9f098": {
        splitting: 1,
        hydrogens: 1,
        assigned: PROTON_TYPES[26],
      },
      "c410bbce-fb75-4503-9b77-79a1add5e08e": {
        splitting: 2,
        hydrogens: 2,
        assigned: PROTON_TYPES[8],
      },
      "43a37221-04c9-449c-a44c-d5660b3f5e44": {
        splitting: 2,
        hydrogens: 2,
        assigned: PROTON_TYPES[8],
      },
      "4ac348f2-f7c8-476e-81a5-0b4c06672c28": {
        splitting: 7,
        hydrogens: 1,
        assigned: PROTON_TYPES[35],
      },
      "6e5d1c8e-06ca-42bf-bfcd-e8f76882e641": {
        splitting: 2,
        hydrogens: 6,
        assigned: PROTON_TYPES[0],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            groupId: "537d91bd-fe68-45c5-8e49-3417ece04ec4",
            moleculeId: "701ca588-4ff9-43df-8933-ca036b7b380b",
            options: {
              showHydrogen: true,
            },
            rangeId: "35e3ee2f-e418-489a-841c-ee0ff17ee0ce-0",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "aa95337f-25e5-4bd9-9259-23c0e2d6153d",
                  isBase: true,
                  moleculeId: "c85d5857-3a76-4fe2-b880-ba80bfc0fbf1",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "6e5d1c8e-06ca-42bf-bfcd-e8f76882e641-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "h2",
                        name: "H",
                      },
                      {
                        id: "h3",
                        name: "H",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-h2",
                        source: "c1",
                        target: "h2",
                        type: 1,
                      },
                      {
                        id: "c1-h3",
                        source: "c1",
                        target: "h3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "8cbfae24-1ead-407c-aa3e-9626ee31342b",
                  isBase: true,
                  moleculeId: "e0bc47af-183d-489c-8602-816ed6cb00d4",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "6e5d1c8e-06ca-42bf-bfcd-e8f76882e641-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "h2",
                        name: "H",
                      },
                      {
                        id: "h3",
                        name: "H",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-h2",
                        source: "c1",
                        target: "h2",
                        type: 1,
                      },
                      {
                        id: "c1-h3",
                        source: "c1",
                        target: "h3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "bf47ae87-700b-4616-b8e2-45ef4851deed",
            isBase: true,
            moleculeId: "0f053162-ff0a-4e5f-bdf6-e9ce19b8d64c",
            options: {
              label: ["c1"],
              showHydrogen: true,
            },
            rangeId: "14c1b284-4e00-4844-8ca4-b81592b3ea67-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "7a5159da-668f-4441-b0cb-b60329f74695",
            isBase: true,
            moleculeId: "47ec8b91-6bff-49da-83df-1f5e9404a46f",
            options: {
              showHydrogen: true,
            },
            rangeId: "b8f63caf-e254-497d-a770-69028ffa8148-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "o1",
                  name: "O",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-o1",
                  source: "c1",
                  target: "o1",
                  type: 2,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "260c485a-2ff4-4441-aa19-8f4fa628bcfa",
            isBase: true,
            moleculeId: "7328a9fc-89d6-4c59-9c85-918bf01c4d44",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "127cbd6d-4fe7-435d-b809-b0961a67e03e",
            isBase: true,
            moleculeId: "e9d038f4-a754-4e7d-9226-e5378a2dbbb3",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "c8ca15b9-a689-45a9-b7ee-55836a07cff7",
            isBase: true,
            moleculeId: "a701b530-3acc-47ce-9892-6f5398e5f3a7",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
      ],
      groupId: "537d91bd-fe68-45c5-8e49-3417ece04ec4",
      isBase: true,
      moleculeId: "f6bda5c6-b51c-4725-82b5-6ee4d47f0247",
      options: {
        showHydrogen: true,
      },
      rangeId: "35e3ee2f-e418-489a-841c-ee0ff17ee0ce-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "c2",
            name: "C",
          },
          {
            id: "c3",
            name: "C",
          },
          {
            id: "c4",
            name: "C",
          },
          {
            id: "c5",
            name: "C",
          },
          {
            id: "c6",
            name: "C",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
          {
            id: "r3",
            name: "R",
          },
          {
            id: "r4",
            name: "R",
          },
          {
            id: "r5",
            name: "R",
          },
          {
            id: "r6",
            name: "R",
          },
        ],
        bonds: [
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "c1-c2",
            source: "c1",
            target: "c2",
            type: 2,
          },
          {
            id: "c2-r2",
            source: "c2",
            target: "r2",
            type: 1,
          },
          {
            id: "c2-c3",
            source: "c2",
            target: "c3",
            type: 1,
          },
          {
            id: "c3-r3",
            source: "c3",
            target: "r3",
            type: 1,
          },
          {
            id: "c3-c4",
            source: "c3",
            target: "c4",
            type: 2,
          },
          {
            id: "c4-r4",
            source: "c4",
            target: "r4",
            type: 1,
          },
          {
            id: "c4-c5",
            source: "c4",
            target: "c5",
            type: 1,
          },
          {
            id: "c5-r5",
            source: "c5",
            target: "r5",
            type: 1,
          },
          {
            id: "c5-c6",
            source: "c5",
            target: "c6",
            type: 2,
          },
          {
            id: "c6-r6",
            source: "c6",
            target: "r6",
            type: 1,
          },
          {
            id: "c6-c1",
            source: "c6",
            target: "c1",
            type: 1,
          },
        ],
      },
    },
  },
  grapes: {
    ranges: {
      "43c8fd64-de50-4be8-8da7-c19967b1e5cc": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "c10e9aba-f6d4-4d05-b885-84d761870d3f": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "72861932-b4f1-45c4-a983-1f8e99df45b0": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "b06fa7cf-7aa4-4ebc-a7da-075f84788592": {
        splitting: 2,
        hydrogens: 2,
        assigned: PROTON_TYPES[18],
      },
      "06471b4b-c236-49b2-ad59-aec4845d9f18": {
        splitting: 7,
        hydrogens: 1,
        assigned: PROTON_TYPES[21],
      },
      "8fbbf351-96d9-4f70-84ea-58c1ba48356e": {
        splitting: 7,
        hydrogens: 1,
        assigned: PROTON_TYPES[2],
      },
      "58351e0f-6a8d-4673-8cff-1c9cae3cb77e": {
        splitting: 2,
        hydrogens: 6,
        assigned: PROTON_TYPES[0],
      },
      "9c8b7fb9-564e-40b9-abc8-d7f31b61bea1": {
        splitting: 2,
        hydrogens: 6,
        assigned: PROTON_TYPES[0],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "8a807079-6c38-444f-8004-41fbc578bfe7",
                  isBase: true,
                  moleculeId: "e07e57bf-1a46-42db-81a2-219faaae331f",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "9c8b7fb9-564e-40b9-abc8-d7f31b61bea1-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "h2",
                        name: "H",
                      },
                      {
                        id: "h3",
                        name: "H",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-h2",
                        source: "c1",
                        target: "h2",
                        type: 1,
                      },
                      {
                        id: "c1-h3",
                        source: "c1",
                        target: "h3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r1",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "0774fbae-569a-48c6-9ef1-5cf2d169cb9f",
                  isBase: true,
                  moleculeId: "cadecd69-231f-439c-91d6-d91d8e054998",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "9c8b7fb9-564e-40b9-abc8-d7f31b61bea1-0",
                  structure: "ch3",
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "36170190-3351-44a7-9570-8826260757b2",
            moleculeId: "85cad3b0-6d69-4ba3-9476-d1840c3bb1a1",
            options: {
              showHydrogen: true,
            },
            rangeId: "06471b4b-c236-49b2-ad59-aec4845d9f18-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r2",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "e1d650f8-8bab-4fac-ab6e-3c9d1eafd656",
                  isBase: true,
                  moleculeId: "7ea4fddd-f44a-4f99-bc9a-89d411b957a8",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        groupId: "ef52f0de-1e83-46f6-87c1-7878dbfc7048",
                        isBase: true,
                        moleculeId: "a24f517a-789f-4db4-a60b-a357e479c0ed",
                        options: {
                          label: ["c1", "h1", "h2", "h3"],
                        },
                        rangeId: "9c8b7fb9-564e-40b9-abc8-d7f31b61bea1-0",
                        structure: {
                          atoms: [
                            {
                              id: "c1",
                              name: "C",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                            {
                              id: "h1",
                              name: "H",
                            },
                            {
                              id: "h2",
                              name: "H",
                            },
                            {
                              id: "h3",
                              name: "H",
                            },
                          ],
                          bonds: [
                            {
                              id: "c1-r1",
                              source: "c1",
                              target: "r1",
                              type: 1,
                            },
                            {
                              id: "c1-h1",
                              source: "c1",
                              target: "h1",
                              type: 1,
                            },
                            {
                              id: "c1-h2",
                              source: "c1",
                              target: "h2",
                              type: 1,
                            },
                            {
                              id: "c1-h3",
                              source: "c1",
                              target: "h3",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "3ad8016e-98fe-4928-8f57-be2d730c4c62",
                        isBase: true,
                        moleculeId: "e7e9b151-bbe3-4784-82c8-14617f142c60",
                        options: {
                          label: ["c1", "h1", "h2", "h3"],
                        },
                        rangeId: "9c8b7fb9-564e-40b9-abc8-d7f31b61bea1-0",
                        structure: {
                          atoms: [
                            {
                              id: "c1",
                              name: "C",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                            {
                              id: "h1",
                              name: "H",
                            },
                            {
                              id: "h2",
                              name: "H",
                            },
                            {
                              id: "h3",
                              name: "H",
                            },
                          ],
                          bonds: [
                            {
                              id: "c1-r1",
                              source: "c1",
                              target: "r1",
                              type: 1,
                            },
                            {
                              id: "c1-h1",
                              source: "c1",
                              target: "h1",
                              type: 1,
                            },
                            {
                              id: "c1-h2",
                              source: "c1",
                              target: "h2",
                              type: 1,
                            },
                            {
                              id: "c1-h3",
                              source: "c1",
                              target: "h3",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "62a9742c-3db2-450b-a860-83098d967789",
                  isBase: true,
                  moleculeId: "25fb4bcd-3901-4cbb-a8b1-b0f935b344dd",
                  options: {
                    label: ["c1"],
                    showHydrogen: true,
                  },
                  rangeId: "8fbbf351-96d9-4f70-84ea-58c1ba48356e-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "r2",
                        name: "R",
                      },
                      {
                        id: "r3",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-r2",
                        source: "c1",
                        target: "r2",
                        type: 1,
                      },
                      {
                        id: "c1-r3",
                        source: "c1",
                        target: "r3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "a4403acb-7f31-4a4b-82b3-0f3938b1f861",
            isBase: true,
            moleculeId: "71f79afb-4941-4479-86c5-cc379f63f577",
            options: {
              label: ["c1"],
              showHydrogen: true,
            },
            rangeId: "8fbbf351-96d9-4f70-84ea-58c1ba48356e-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
      ],
      groupId: "36170190-3351-44a7-9570-8826260757b2",
      isBase: true,
      moleculeId: "a7e02636-93c8-41c7-ae90-c362d2d3364f",
      options: {
        showHydrogen: true,
      },
      rangeId: "06471b4b-c236-49b2-ad59-aec4845d9f18-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "o1",
            name: "O",
          },
          {
            id: "o2",
            name: "O",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
          {
            id: "p1",
          },
        ],
        bonds: [
          {
            id: "c1-o1",
            source: "c1",
            target: "o1",
            type: 2,
          },
          {
            id: "c1-o2",
            source: "c1",
            target: "o2",
            type: 1,
          },
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "o2-r2",
            source: "o2",
            target: "r2",
            type: 1,
          },
          {
            id: "o2-p1",
            source: "o2",
            target: "p1",
            type: 0,
          },
        ],
      },
    },
  },
  mango: {
    ranges: {
      "2f5b77e9-0ad2-485d-9811-d36fbb4346bc": {
        assigned: FUNCTIONAL_GROUPS[4],
      },
      "892c4bb9-a370-46fc-b218-cf6a4d844ec5": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "a1b548df-1708-4453-a15c-f23941e0f83d": {
        assigned: FUNCTIONAL_GROUPS[18],
      },
      "b51a24da-1904-48ce-9c96-b2166de576ee": {
        assigned: FUNCTIONAL_GROUPS[5],
      },
      "66cb661d-5c90-47d5-9e4e-e85b873558cc": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "066b2d2a-6d6b-4c76-aa31-9abd2ec8cb1c": {
        splitting: 24,
        hydrogens: 1,
        assigned: PROTON_TYPES[3],
      },
      "1426e33d-440f-469d-a404-faae8315b3c2": {
        splitting: 24,
        hydrogens: 1,
        assigned: PROTON_TYPES[3],
      },
      "16bb9769-d491-4182-af08-2702de8fd58a": {
        splitting: 4,
        hydrogens: 2,
        assigned: PROTON_TYPES[20],
      },
      "119584d4-99e3-4eec-925b-8210e14aa722": {
        splitting: 22,
        hydrogens: 3,
        assigned: PROTON_TYPES[0],
      },
      "b24d064a-e330-41b8-9cad-229e2fdc762e": {
        splitting: 3,
        hydrogens: 3,
        assigned: PROTON_TYPES[0],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "7565be27-724b-4579-b985-bfca37666ac5",
                  isBase: true,
                  moleculeId: "4d2bd272-a80b-4b68-8f15-9e9499bd8945",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r1",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "c4e3a2e6-aac6-456d-8a39-b0cfe101fc9a",
                  isBase: true,
                  moleculeId: "71bbac69-5f16-4b28-a9be-44beadd037f1",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "b24d064a-e330-41b8-9cad-229e2fdc762e-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "h2",
                        name: "H",
                      },
                      {
                        id: "h3",
                        name: "H",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-h2",
                        source: "c1",
                        target: "h2",
                        type: 1,
                      },
                      {
                        id: "c1-h3",
                        source: "c1",
                        target: "h3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "be245097-b462-497b-8904-16c203a972a1",
            moleculeId: "a1266c08-121d-4c78-8f51-42825caaaf4c",
            options: {
              showHydrogen: true,
            },
            rangeId: "16bb9769-d491-4182-af08-2702de8fd58a-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r2",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "b0bc34fc-9ed3-49f3-8b58-70b039049aa2",
                  isBase: true,
                  moleculeId: "52554ed5-6956-4d53-8aa4-d9723f423c56",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r4",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "c35addfb-2ca5-4bf7-addd-9e31630b8c9d",
                  isBase: true,
                  moleculeId: "980b97ef-5e68-421e-bf97-c84c1be2155f",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "a967c000-161f-4075-9feb-a6adcbf596a4",
                  isBase: true,
                  moleculeId: "e235019f-cd71-447c-ba05-777c9bd490c8",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "b24d064a-e330-41b8-9cad-229e2fdc762e-0",
                  structure: "ch3",
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "c4b1185e-d7c6-4235-87ac-47f7743bf5fc",
            isBase: true,
            moleculeId: "e6d3b9d3-d0ad-42bd-956e-fd30e3226469",
            rangeId: "b51a24da-1904-48ce-9c96-b2166de576ee-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "c2",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
                {
                  id: "r4",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-c2",
                  source: "c1",
                  target: "c2",
                  type: 2,
                },
                {
                  id: "c2-r3",
                  source: "c2",
                  target: "r3",
                  type: 1,
                },
                {
                  id: "c2-r4",
                  source: "c2",
                  target: "r4",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
      ],
      groupId: "be245097-b462-497b-8904-16c203a972a1",
      isBase: true,
      moleculeId: "1b348b21-7682-4d51-bddc-3f1c675b05d7",
      options: {
        showHydrogen: true,
      },
      rangeId: "16bb9769-d491-4182-af08-2702de8fd58a-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "o1",
            name: "O",
          },
          {
            id: "o2",
            name: "O",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
          {
            id: "p1",
          },
        ],
        bonds: [
          {
            id: "c1-o1",
            source: "c1",
            target: "o1",
            type: 2,
          },
          {
            id: "c1-o2",
            source: "c1",
            target: "o2",
            type: 1,
          },
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "o2-r2",
            source: "o2",
            target: "r2",
            type: 1,
          },
          {
            id: "o2-p1",
            source: "o2",
            target: "p1",
            type: 0,
          },
        ],
      },
    },
  },
  "roasted-almonds": {
    ranges: {
      "0a072260-4992-41e1-83cf-c6dec07d628d": {
        assigned: FUNCTIONAL_GROUPS[4],
      },
      "15fdbc01-5dd6-41f9-9f37-5facd78c22a3": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "c7a71e87-03f2-47ea-a3bf-9439efe19b89": {
        assigned: FUNCTIONAL_GROUPS[18],
      },
      "5af67c2f-abc7-40b6-9ec5-2d618c3a5540": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "bfe39250-19d8-453e-a72c-1ae9eb539303": {
        splitting: 22,
        hydrogens: 1,
        assigned: PROTON_TYPES[36],
      },
      "d680ae49-f611-4570-8f50-fcbb23a01493": {
        splitting: 22,
        hydrogens: 1,
        assigned: PROTON_TYPES[36],
      },
      "ec089a89-f0c5-4d39-9503-cbaff97afe9a": {
        splitting: 22,
        hydrogens: 1,
        assigned: PROTON_TYPES[36],
      },
      "b2293d13-f749-44bd-866f-6a35e35fd165": {
        splitting: 1,
        hydrogens: 2,
        assigned: PROTON_TYPES[38],
      },
      "dc5794d0-c68e-4781-8d32-668dc824939c": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[21],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        assign: [
                          {
                            molecule: {
                              groupId: "1714bb29-d5e7-4be6-b0ea-2b2ed8cff441",
                              isBase: true,
                              moleculeId:
                                "37445e26-b153-46ab-9635-d6f2080c6958",
                              options: {
                                label: ["c1", "h1", "h2", "h3"],
                              },
                              rangeId: "dc5794d0-c68e-4781-8d32-668dc824939c-0",
                              structure: "ch3",
                            },
                            parentAtom: "r2",
                            sourceAtom: "r1",
                          },
                        ],
                        groupId: "6df78c66-3e69-4512-87c5-3705b3f65169",
                        isBase: true,
                        moleculeId: "f2b1dd7f-a042-484e-8bd4-604f14b5e3a1",
                        rangeId: "c7a71e87-03f2-47ea-a3bf-9439efe19b89-0",
                        structure: {
                          atoms: [
                            {
                              id: "c1",
                              name: "C",
                            },
                            {
                              id: "o1",
                              name: "O",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                            {
                              id: "r2",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "c1-o1",
                              source: "c1",
                              target: "o1",
                              type: 2,
                            },
                            {
                              id: "c1-r1",
                              source: "c1",
                              target: "r1",
                              type: 1,
                            },
                            {
                              id: "c1-r2",
                              source: "c1",
                              target: "r2",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "6f13f4b8-cb4f-4e87-9a21-4f8b2bd7f1bd",
                  moleculeId: "be4afd9d-e8c5-4de9-80b7-8b9655c32b31",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "b2293d13-f749-44bd-866f-6a35e35fd165-0",
                  structure: {
                    atoms: [
                      {
                        id: "o1",
                        name: "O",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "r2",
                        name: "R",
                      },
                      {
                        id: "p1",
                      },
                    ],
                    bonds: [
                      {
                        id: "o1-r1",
                        source: "o1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "o1-r2",
                        source: "o1",
                        target: "r2",
                        type: 1,
                      },
                      {
                        id: "o1-p1",
                        source: "o1",
                        target: "p1",
                        type: 0,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "bd8b37af-2951-4346-a75a-ea0d4b30f2a4",
                  isBase: true,
                  moleculeId: "93e453f1-c79c-4ba6-97c7-97e311b9ef4b",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "6f13f4b8-cb4f-4e87-9a21-4f8b2bd7f1bd",
            moleculeId: "9595d0bf-53cf-4331-a64f-d18485f12518",
            options: {
              showHydrogen: true,
            },
            rangeId: "b2293d13-f749-44bd-866f-6a35e35fd165-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "fd4c32e6-ee1b-4303-af3c-1ceb02e0e0af",
            isBase: true,
            moleculeId: "8cdcecc5-d556-41e0-8204-1e764c7b57f0",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "96d4402e-b2f5-4f43-9a0c-f23f3a795a30",
            isBase: true,
            moleculeId: "f2c79c2f-7377-407b-9169-22d0a524dcb4",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "33b1ce15-9ba6-480f-87f2-d4def27f0017",
            isBase: true,
            moleculeId: "c345448d-9075-498f-b5ff-650977b24118",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
      ],
      groupId: "6f13f4b8-cb4f-4e87-9a21-4f8b2bd7f1bd",
      isBase: true,
      moleculeId: "38df9c59-2b0e-414c-bae2-8e09df4016c4",
      options: {
        showHydrogen: true,
      },
      rangeId: "b2293d13-f749-44bd-866f-6a35e35fd165-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "c2",
            name: "C",
          },
          {
            id: "c3",
            name: "C",
          },
          {
            id: "c4",
            name: "C",
          },
          {
            id: "o1",
            name: "O",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
          {
            id: "r3",
            name: "R",
          },
          {
            id: "r4",
            name: "R",
          },
          {
            id: "p1",
            name: "",
          },
          {
            id: "p2",
            name: "",
          },
          {
            id: "p3",
            name: "",
          },
          {
            id: "p4",
            name: "",
          },
          {
            id: "p5",
            name: "",
          },
          {
            id: "p6",
            name: "",
          },
          {
            id: "p7",
            name: "",
          },
          {
            id: "p8",
            name: "",
          },
          {
            id: "p9",
            name: "",
          },
          {
            id: "p10",
            name: "",
          },
          {
            id: "p11",
            name: "",
          },
          {
            id: "p12",
            name: "",
          },
          {
            id: "p13",
            name: "",
          },
          {
            id: "p14",
            name: "",
          },
          {
            id: "p15",
            name: "",
          },
          {
            id: "p16",
            name: "",
          },
          {
            id: "p17",
            name: "",
          },
          {
            id: "p18",
            name: "",
          },
          {
            id: "p19",
            name: "",
          },
          {
            id: "p20",
            name: "",
          },
          {
            id: "p21",
            name: "",
          },
          {
            id: "p22",
            name: "",
          },
          {
            id: "p23",
            name: "",
          },
          {
            id: "p24",
            name: "",
          },
          {
            id: "p25",
            name: "",
          },
          {
            id: "p26",
            name: "",
          },
          {
            id: "p27",
            name: "",
          },
          {
            id: "p28",
            name: "",
          },
          {
            id: "p29",
            name: "",
          },
          {
            id: "p30",
            name: "",
          },
          {
            id: "p31",
            name: "",
          },
          {
            id: "p32",
            name: "",
          },
          {
            id: "p33",
            name: "",
          },
          {
            id: "p34",
            name: "",
          },
          {
            id: "p35",
            name: "",
          },
          {
            id: "p36",
            name: "",
          },
          {
            id: "p37",
            name: "",
          },
          {
            id: "p38",
            name: "",
          },
          {
            id: "p39",
            name: "",
          },
          {
            id: "p40",
            name: "",
          },
          {
            id: "p41",
            name: "",
          },
          {
            id: "p42",
            name: "",
          },
          {
            id: "p43",
            name: "",
          },
          {
            id: "p44",
            name: "",
          },
          {
            id: "p45",
            name: "",
          },
          {
            id: "p46",
            name: "",
          },
          {
            id: "p47",
            name: "",
          },
          {
            id: "p48",
            name: "",
          },
          {
            id: "p49",
            name: "",
          },
          {
            id: "p50",
            name: "",
          },
          {
            id: "p51",
            name: "",
          },
          {
            id: "p52",
            name: "",
          },
          {
            id: "p53",
            name: "",
          },
          {
            id: "p54",
            name: "",
          },
          {
            id: "p55",
            name: "",
          },
          {
            id: "p56",
            name: "",
          },
          {
            id: "p57",
            name: "",
          },
          {
            id: "p58",
            name: "",
          },
          {
            id: "p59",
            name: "",
          },
          {
            id: "p60",
            name: "",
          },
          {
            id: "p61",
            name: "",
          },
        ],
        bonds: [
          {
            id: "o1-p1",
            source: "o1",
            target: "p1",
            type: 0,
          },
          {
            id: "o1-p2",
            source: "o1",
            target: "p2",
            type: 0,
          },
          {
            id: "o1-p3",
            source: "o1",
            target: "p3",
            type: 0,
          },
          {
            id: "o1-c1",
            multiplier: 2,
            source: "o1",
            target: "c1",
            type: 1,
          },
          {
            id: "o1-p4",
            source: "o1",
            target: "p5",
            type: 0,
          },
          {
            id: "c1-p6",
            source: "c1",
            target: "p6",
            type: 0,
          },
          {
            id: "c1-p7",
            source: "c1",
            target: "p7",
            type: 0,
          },
          {
            id: "c1-p8",
            source: "c1",
            target: "p8",
            type: 0,
          },
          {
            id: "c1-p9",
            source: "c1",
            target: "p9",
            type: 0,
          },
          {
            id: "c1-p10",
            source: "c1",
            target: "p10",
            type: 0,
          },
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "c1-p11",
            source: "c1",
            target: "p11",
            type: 0,
          },
          {
            id: "c1-p12",
            source: "c1",
            target: "p12",
            type: 0,
          },
          {
            id: "c1-p13",
            source: "c1",
            target: "p13",
            type: 0,
          },
          {
            id: "c1-p14",
            source: "c1",
            target: "p14",
            type: 0,
          },
          {
            id: "c1-p15",
            source: "c1",
            target: "p15",
            type: 0,
          },
          {
            id: "c1-c2",
            source: "c1",
            target: "c2",
            type: 2,
          },
          {
            id: "c1-p16",
            source: "c1",
            target: "p16",
            type: 0,
          },
          {
            id: "c1-p17",
            source: "c1",
            target: "p17",
            type: 0,
          },
          {
            id: "c1-p18",
            source: "c1",
            target: "p18",
            type: 0,
          },
          {
            id: "c1-p19",
            source: "c1",
            target: "p19",
            type: 0,
          },
          {
            id: "c2-p20",
            source: "c2",
            target: "p20",
            type: 0,
          },
          {
            id: "c2-p21",
            source: "c2",
            target: "p21",
            type: 0,
          },
          {
            id: "c2-p22",
            source: "c2",
            target: "p22",
            type: 0,
          },
          {
            id: "c2-p23",
            source: "c2",
            target: "p23",
            type: 0,
          },
          {
            id: "c2-p24",
            source: "c2",
            target: "p24",
            type: 0,
          },
          {
            id: "c2-r2",
            source: "c2",
            target: "r2",
            type: 1,
          },
          {
            id: "c2-p25",
            source: "c2",
            target: "p25",
            type: 0,
          },
          {
            id: "c2-p26",
            source: "c2",
            target: "p26",
            type: 0,
          },
          {
            id: "c2-p27",
            source: "c2",
            target: "p27",
            type: 0,
          },
          {
            id: "c2-p28",
            source: "c2",
            target: "p28",
            type: 0,
          },
          {
            id: "c2-p29",
            source: "c2",
            target: "p29",
            type: 0,
          },
          {
            id: "c2-c3",
            source: "c2",
            target: "c3",
            type: 1,
          },
          {
            id: "c2-p30",
            source: "c2",
            target: "p30",
            type: 0,
          },
          {
            id: "c2-p31",
            source: "c2",
            target: "p31",
            type: 0,
          },
          {
            id: "c2-p32",
            source: "c2",
            target: "p32",
            type: 0,
          },
          {
            id: "c2-p33",
            source: "c2",
            target: "p33",
            type: 0,
          },
          {
            id: "c3-p34",
            source: "c3",
            target: "p34",
            type: 0,
          },
          {
            id: "c3-p35",
            source: "c3",
            target: "p35",
            type: 0,
          },
          {
            id: "c3-p36",
            source: "c3",
            target: "p36",
            type: 0,
          },
          {
            id: "c3-p37",
            source: "c3",
            target: "p37",
            type: 0,
          },
          {
            id: "c3-p38",
            source: "c3",
            target: "p38",
            type: 0,
          },
          {
            id: "c3-r3",
            source: "c3",
            target: "r3",
            type: 1,
          },
          {
            id: "c3-p39",
            source: "c3",
            target: "p39",
            type: 0,
          },
          {
            id: "c3-p40",
            source: "c3",
            target: "p40",
            type: 0,
          },
          {
            id: "c3-p41",
            source: "c3",
            target: "p41",
            type: 0,
          },
          {
            id: "c3-p42",
            source: "c3",
            target: "p42",
            type: 0,
          },
          {
            id: "c3-p43",
            source: "c3",
            target: "p43",
            type: 0,
          },
          {
            id: "c3-c4",
            source: "c3",
            target: "c4",
            type: 2,
          },
          {
            id: "c3-p44",
            source: "c3",
            target: "p44",
            type: 0,
          },
          {
            id: "c3-p45",
            source: "c3",
            target: "p45",
            type: 0,
          },
          {
            id: "c3-p46",
            source: "c3",
            target: "p46",
            type: 0,
          },
          {
            id: "c3-p47",
            source: "c3",
            target: "p47",
            type: 0,
          },
          {
            id: "c4-p48",
            source: "c4",
            target: "p48",
            type: 0,
          },
          {
            id: "c4-p49",
            source: "c4",
            target: "p49",
            type: 0,
          },
          {
            id: "c4-p50",
            source: "c4",
            target: "p50",
            type: 0,
          },
          {
            id: "c4-p51",
            source: "c4",
            target: "p51",
            type: 0,
          },
          {
            id: "c4-p52",
            source: "c4",
            target: "p52",
            type: 0,
          },
          {
            id: "c4-r4",
            source: "c4",
            target: "r4",
            type: 1,
          },
          {
            id: "c4-p53",
            source: "c4",
            target: "p53",
            type: 0,
          },
          {
            id: "c4-p54",
            source: "c4",
            target: "p54",
            type: 0,
          },
          {
            id: "c4-p55",
            source: "c4",
            target: "p55",
            type: 0,
          },
          {
            id: "c4-p56",
            source: "c4",
            target: "p56",
            type: 0,
          },
          {
            id: "c4-p57",
            source: "c4",
            target: "p57",
            type: 0,
          },
          {
            id: "c4-o1",
            multiplier: 2,
            source: "c4",
            target: "o1",
            type: 1,
          },
          {
            id: "c4-p58",
            source: "c4",
            target: "p58",
            type: 0,
          },
          {
            id: "c4-p59",
            source: "c4",
            target: "p59",
            type: 0,
          },
          {
            id: "c4-p60",
            source: "c4",
            target: "p60",
            type: 0,
          },
          {
            id: "c4-p61",
            source: "c4",
            target: "p61",
            type: 0,
          },
        ],
      },
    },
  },
  "raspberry-ketone": {
    ranges: {
      "57d2886c-b868-42c4-af5d-74a862627bee": {
        assigned: FUNCTIONAL_GROUPS[1],
      },
      "aa0d5041-2584-4fe1-92da-14462c9f0dac": {
        assigned: FUNCTIONAL_GROUPS[13],
      },
      "683362c2-8b1b-43d8-9abb-cfcdc5ed7954": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "f4886aad-aedc-4f26-ae9c-dbf02a1dd6b5": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "63d7d139-42b3-48fc-b826-123c51bbf666": {
        assigned: FUNCTIONAL_GROUPS[14],
      },
      "c2c13a61-5a8b-42dc-9b5d-4068931379f5": {
        splitting: 2,
        hydrogens: 2,
        assigned: PROTON_TYPES[8],
      },
      "01a01e10-416c-4b6c-b699-1aac379dcffa": {
        splitting: 2,
        hydrogens: 2,
        assigned: PROTON_TYPES[8],
      },
      "f144f0aa-4d98-4c1d-b701-6a82d18470ef": {
        splitting: 21,
        hydrogens: 1,
        assigned: PROTON_TYPES[12],
      },
      "a2067c96-013b-461f-aee1-577eddc40573": {
        splitting: 3,
        hydrogens: 2,
        assigned: PROTON_TYPES[9],
      },
      "4eb2b378-97c5-441d-95c2-5a707fcbda53": {
        splitting: 3,
        hydrogens: 2,
        assigned: PROTON_TYPES[24],
      },
      "fbf623a0-a36f-4949-ac03-1bf372528132": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[24],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        assign: [
                          {
                            molecule: {
                              groupId: "835b1cd9-5c3e-494c-aee1-ec8ae2fbe3e2",
                              isBase: true,
                              moleculeId:
                                "a44dff0b-02a8-43fd-87c5-2d98a615db13",
                              options: {
                                label: ["c1", "h1", "h2", "h3"],
                              },
                              rangeId: "fbf623a0-a36f-4949-ac03-1bf372528132-0",
                              structure: {
                                atoms: [
                                  {
                                    id: "c1",
                                    name: "C",
                                  },
                                  {
                                    id: "r1",
                                    name: "R",
                                  },
                                  {
                                    id: "h1",
                                    name: "H",
                                  },
                                  {
                                    id: "h2",
                                    name: "H",
                                  },
                                  {
                                    id: "h3",
                                    name: "H",
                                  },
                                ],
                                bonds: [
                                  {
                                    id: "c1-r1",
                                    source: "c1",
                                    target: "r1",
                                    type: 1,
                                  },
                                  {
                                    id: "c1-h1",
                                    source: "c1",
                                    target: "h1",
                                    type: 1,
                                  },
                                  {
                                    id: "c1-h2",
                                    source: "c1",
                                    target: "h2",
                                    type: 1,
                                  },
                                  {
                                    id: "c1-h3",
                                    source: "c1",
                                    target: "h3",
                                    type: 1,
                                  },
                                ],
                              },
                            },
                            parentAtom: "r2",
                            sourceAtom: "r1",
                          },
                        ],
                        groupId: "835cc709-c60c-450d-8211-9c5e2f427151",
                        moleculeId: "d2319281-d498-4575-9c91-fa7ec3cee5dd",
                        options: {
                          showHydrogen: true,
                        },
                        rangeId: "4eb2b378-97c5-441d-95c2-5a707fcbda53-0",
                        structure: {
                          atoms: [
                            {
                              id: "c1",
                              name: "C",
                            },
                            {
                              id: "o1",
                              name: "O",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                            {
                              id: "r2",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "c1-o1",
                              source: "c1",
                              target: "o1",
                              type: 2,
                            },
                            {
                              id: "c1-r1",
                              source: "c1",
                              target: "r1",
                              type: 1,
                            },
                            {
                              id: "c1-r2",
                              source: "c1",
                              target: "r2",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "fc0d108f-0918-4ce3-b66b-06d9bfbef6f8",
                        isBase: true,
                        moleculeId: "de350465-4747-476a-aa26-4adb44238818",
                        rangeId: "default",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "835cc709-c60c-450d-8211-9c5e2f427151",
                  isBase: true,
                  moleculeId: "f3de3a2f-b205-4fe5-bacb-7fa64707329d",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "4eb2b378-97c5-441d-95c2-5a707fcbda53-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "r2",
                        name: "R",
                      },
                      {
                        id: "r3",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-r2",
                        source: "c1",
                        target: "r2",
                        type: 1,
                      },
                      {
                        id: "c1-r3",
                        source: "c1",
                        target: "r3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "23483f1f-56c4-4e80-857d-433b618dab91",
            moleculeId: "e736fa3f-41b7-4892-9e24-3cbf21c94337",
            options: {
              showHydrogen: true,
            },
            rangeId: "a2067c96-013b-461f-aee1-577eddc40573-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "h2",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-h2",
                  source: "c1",
                  target: "h2",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r3",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "b966d60b-8035-468a-8f7b-7d2394e934f0",
            isBase: true,
            moleculeId: "eaf9e80b-e671-4875-8aa6-2a965324e929",
            rangeId: "57d2886c-b868-42c4-af5d-74a862627bee-0",
            structure: {
              atoms: [
                {
                  id: "o1",
                  name: "O",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "p1",
                },
              ],
              bonds: [
                {
                  id: "o1-r1",
                  source: "o1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "o1-h1",
                  source: "o1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "o1-p1",
                  source: "o1",
                  target: "p1",
                  type: 0,
                },
              ],
            },
          },
          parentAtom: "r6",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "14ffae54-bd72-4278-a692-fb60aa7d1093",
            isBase: true,
            moleculeId: "e7923df2-0f68-4984-bb60-18650c5d919b",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "5e2eb0e7-d490-4472-9142-a206c46997fb",
            isBase: true,
            moleculeId: "8a8012d6-50c6-4bc9-b6df-024716531703",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "6b98c313-e39c-4339-adf0-38a2efa2799e",
            isBase: true,
            moleculeId: "ffe3e8f3-8022-4526-8f16-f11239ec9b68",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r5",
          sourceAtom: "r1",
        },
        {
          molecule: {
            groupId: "9dcbefc5-8cff-46c8-9fef-4dc753de06dc",
            isBase: true,
            moleculeId: "a9f2cc0d-c1d8-4477-a87b-ff0340054101",
            rangeId: "default",
            structure: {
              atoms: [
                {
                  id: "h1",
                  label: true,
                  name: "H",
                },
                {
                  id: "r1",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "h1-r1",
                  source: "h1",
                  target: "r1",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r4",
          sourceAtom: "r1",
        },
      ],
      groupId: "23483f1f-56c4-4e80-857d-433b618dab91",
      isBase: true,
      moleculeId: "5c405b87-a5c6-412c-949c-0d6ac4fedcc4",
      options: {
        showHydrogen: true,
      },
      rangeId: "a2067c96-013b-461f-aee1-577eddc40573-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "c2",
            name: "C",
          },
          {
            id: "c3",
            name: "C",
          },
          {
            id: "c4",
            name: "C",
          },
          {
            id: "c5",
            name: "C",
          },
          {
            id: "c6",
            name: "C",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
          {
            id: "r3",
            name: "R",
          },
          {
            id: "r4",
            name: "R",
          },
          {
            id: "r5",
            name: "R",
          },
          {
            id: "r6",
            name: "R",
          },
        ],
        bonds: [
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "c1-c2",
            source: "c1",
            target: "c2",
            type: 2,
          },
          {
            id: "c2-r2",
            source: "c2",
            target: "r2",
            type: 1,
          },
          {
            id: "c2-c3",
            source: "c2",
            target: "c3",
            type: 1,
          },
          {
            id: "c3-r3",
            source: "c3",
            target: "r3",
            type: 1,
          },
          {
            id: "c3-c4",
            source: "c3",
            target: "c4",
            type: 2,
          },
          {
            id: "c4-r4",
            source: "c4",
            target: "r4",
            type: 1,
          },
          {
            id: "c4-c5",
            source: "c4",
            target: "c5",
            type: 1,
          },
          {
            id: "c5-r5",
            source: "c5",
            target: "r5",
            type: 1,
          },
          {
            id: "c5-c6",
            source: "c5",
            target: "c6",
            type: 2,
          },
          {
            id: "c6-r6",
            source: "c6",
            target: "r6",
            type: 1,
          },
          {
            id: "c6-c1",
            source: "c6",
            target: "c1",
            type: 1,
          },
        ],
      },
    },
  },
  tutorial: {
    ranges: {
      "c91fac77-84f0-4e8f-8502-6ab2b4c2d88e": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "c004c7dc-ae2e-4478-b524-5d1a1f2d20f5": {
        assigned: FUNCTIONAL_GROUPS[19],
      },
      "9640fc5e-de54-4ace-b307-03ccae9ce52a": {
        splitting: 4,
        hydrogens: 2,
        assigned: PROTON_TYPES[1],
      },
      "e726f172-8cc7-450f-b2dc-c2e4f98ab204": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[0],
      },
      "6658928c-7bd3-4708-ac2a-f733bf83fcd3": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[0],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            groupId: "72c6e36c-8197-40cf-9c66-43147ff1ddab",
            isBase: true,
            moleculeId: "fc21013a-6895-4581-8b1f-2589c7bac372",
            options: {
              label: ["c1", "h1", "h2", "h3"],
            },
            rangeId: "6658928c-7bd3-4708-ac2a-f733bf83fcd3-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "h2",
                  name: "H",
                },
                {
                  id: "h3",
                  name: "H",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-h2",
                  source: "c1",
                  target: "h2",
                  type: 1,
                },
                {
                  id: "c1-h3",
                  source: "c1",
                  target: "h3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r1",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "78eeac7a-7189-48a8-be0d-d281fb49c53b",
                  isBase: true,
                  moleculeId: "0a77070c-8062-4ca4-a9ee-0ea9b31e2964",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "6658928c-7bd3-4708-ac2a-f733bf83fcd3-0",
                  structure: "ch3",
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
            ],
            groupId: "9cbb2e70-3465-40bd-aa86-a99b4446a2a5",
            isBase: true,
            moleculeId: "f75e4675-bc8f-41b5-bda6-db577db5e023",
            options: {
              label: ["c1", "h1", "h2"],
              showHydrogen: true,
            },
            rangeId: "9640fc5e-de54-4ace-b307-03ccae9ce52a-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "h2",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-h2",
                  source: "c1",
                  target: "h2",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
      ],
      groupId: "7dd3efa3-bd2b-49ec-8f4d-791121f63204",
      isBase: true,
      moleculeId: "6bd97618-9d54-4636-8f3b-bc97620a7dd6",
      rangeId: "c004c7dc-ae2e-4478-b524-5d1a1f2d20f5-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "o1",
            name: "O",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
        ],
        bonds: [
          {
            id: "c1-o1",
            source: "c1",
            target: "o1",
            type: 2,
          },
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "c1-r2",
            source: "c1",
            target: "r2",
            type: 1,
          },
        ],
      },
    },
  },
  whiskey: {
    ranges: {
      "ff5d5bf2-a5be-43ce-93d1-aa85937445ba": {
        assigned: FUNCTIONAL_GROUPS[6],
      },
      "0ed9d084-4934-475b-9365-607c2ce059c1": {
        assigned: FUNCTIONAL_GROUPS[18],
      },
      "44ba959b-23a6-4113-a3ac-2ceef1764aee": {
        assigned: FUNCTIONAL_GROUPS[15],
      },
      "83239b4f-0929-4622-9cbe-d0e4cd6d2140": {
        splitting: 4,
        hydrogens: 2,
        assigned: PROTON_TYPES[20],
      },
      "721f23bb-594a-4248-b189-9717bbb3cbc8": {
        splitting: 3,
        hydrogens: 2,
        assigned: PROTON_TYPES[21],
      },
      "ea5fcea6-3980-4c99-ab8f-7f9cc7623c2b": {
        splitting: 3,
        hydrogens: 2,
        assigned: PROTON_TYPES[24],
      },
      "9c96a9d6-6425-42fa-9a82-19d1bb1c8bdb": {
        splitting: 1,
        hydrogens: 3,
        assigned: PROTON_TYPES[24],
      },
      "3de1d109-43a7-426e-a98b-e2e9872374cb": {
        splitting: 3,
        hydrogens: 3,
        assigned: PROTON_TYPES[0],
      },
    },
    build: {
      assign: [
        {
          molecule: {
            assign: [
              {
                molecule: {
                  groupId: "a27cac16-f098-4b7d-b709-eb2537142acd",
                  isBase: true,
                  moleculeId: "af5d811d-8085-45e9-bf4a-5d0b3a553e4d",
                  options: {
                    label: ["c1", "h1", "h2", "h3"],
                  },
                  rangeId: "3de1d109-43a7-426e-a98b-e2e9872374cb-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "h2",
                        name: "H",
                      },
                      {
                        id: "h3",
                        name: "H",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-h2",
                        source: "c1",
                        target: "h2",
                        type: 1,
                      },
                      {
                        id: "c1-h3",
                        source: "c1",
                        target: "h3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "4dbfc025-fafa-48eb-9dd5-ae38dd74f08a",
                  isBase: true,
                  moleculeId: "2cdb9a1e-e53e-46e1-90c7-077a7b447bce",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r1",
                sourceAtom: "r1",
              },
            ],
            groupId: "9b9003cc-6259-4acc-bbe5-1665e9630b08",
            moleculeId: "2c6827b4-e29b-45b0-8d06-1c25bab927a8",
            options: {
              showHydrogen: true,
            },
            rangeId: "83239b4f-0929-4622-9cbe-d0e4cd6d2140-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r2",
          sourceAtom: "r2",
        },
        {
          molecule: {
            assign: [
              {
                molecule: {
                  assign: [
                    {
                      molecule: {
                        assign: [
                          {
                            molecule: {
                              groupId: "62da45b6-481d-4157-9f3f-b8b7700a9e6f",
                              isBase: true,
                              moleculeId:
                                "c9dd35fc-aa02-4fd6-8890-66a956b34466",
                              options: {
                                label: ["c1", "h1", "h2", "h3"],
                              },
                              rangeId: "3de1d109-43a7-426e-a98b-e2e9872374cb-0",
                              structure: {
                                atoms: [
                                  {
                                    id: "c1",
                                    name: "C",
                                  },
                                  {
                                    id: "r1",
                                    name: "R",
                                  },
                                  {
                                    id: "h1",
                                    name: "H",
                                  },
                                  {
                                    id: "h2",
                                    name: "H",
                                  },
                                  {
                                    id: "h3",
                                    name: "H",
                                  },
                                ],
                                bonds: [
                                  {
                                    id: "c1-r1",
                                    source: "c1",
                                    target: "r1",
                                    type: 1,
                                  },
                                  {
                                    id: "c1-h1",
                                    source: "c1",
                                    target: "h1",
                                    type: 1,
                                  },
                                  {
                                    id: "c1-h2",
                                    source: "c1",
                                    target: "h2",
                                    type: 1,
                                  },
                                  {
                                    id: "c1-h3",
                                    source: "c1",
                                    target: "h3",
                                    type: 1,
                                  },
                                ],
                              },
                            },
                            parentAtom: "r2",
                            sourceAtom: "r1",
                          },
                        ],
                        groupId: "1af53eed-a8c9-4957-8175-0acca93fb12d",
                        moleculeId: "c158316d-6b76-486e-95ed-249c9532c2ca",
                        options: {
                          showHydrogen: true,
                        },
                        rangeId: "ea5fcea6-3980-4c99-ab8f-7f9cc7623c2b-0",
                        structure: {
                          atoms: [
                            {
                              id: "c1",
                              name: "C",
                            },
                            {
                              id: "o1",
                              name: "O",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                            {
                              id: "r2",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "c1-o1",
                              source: "c1",
                              target: "o1",
                              type: 2,
                            },
                            {
                              id: "c1-r1",
                              source: "c1",
                              target: "r1",
                              type: 1,
                            },
                            {
                              id: "c1-r2",
                              source: "c1",
                              target: "r2",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r2",
                      sourceAtom: "r1",
                    },
                    {
                      molecule: {
                        groupId: "b2e6e364-d506-4968-a777-05b4f7d2ffe2",
                        isBase: true,
                        moleculeId: "3a30dfd3-5f80-488f-adfb-fe78eb94d4b1",
                        rangeId: "default",
                        structure: {
                          atoms: [
                            {
                              id: "h1",
                              label: true,
                              name: "H",
                            },
                            {
                              id: "r1",
                              name: "R",
                            },
                          ],
                          bonds: [
                            {
                              id: "h1-r1",
                              source: "h1",
                              target: "r1",
                              type: 1,
                            },
                          ],
                        },
                      },
                      parentAtom: "r3",
                      sourceAtom: "r1",
                    },
                  ],
                  groupId: "1af53eed-a8c9-4957-8175-0acca93fb12d",
                  isBase: true,
                  moleculeId: "05a368b9-02bd-4b53-aaa4-36cc0fb01199",
                  options: {
                    showHydrogen: true,
                  },
                  rangeId: "ea5fcea6-3980-4c99-ab8f-7f9cc7623c2b-0",
                  structure: {
                    atoms: [
                      {
                        id: "c1",
                        name: "C",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                      {
                        id: "h1",
                        name: "H",
                      },
                      {
                        id: "r2",
                        name: "R",
                      },
                      {
                        id: "r3",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "c1-r1",
                        source: "c1",
                        target: "r1",
                        type: 1,
                      },
                      {
                        id: "c1-h1",
                        source: "c1",
                        target: "h1",
                        type: 1,
                      },
                      {
                        id: "c1-r2",
                        source: "c1",
                        target: "r2",
                        type: 1,
                      },
                      {
                        id: "c1-r3",
                        source: "c1",
                        target: "r3",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r2",
                sourceAtom: "r1",
              },
              {
                molecule: {
                  groupId: "743c566b-7e3e-45a9-a376-9d51ac32a1f8",
                  isBase: true,
                  moleculeId: "05b3c9cc-96a1-4944-96ca-18b384097a32",
                  rangeId: "default",
                  structure: {
                    atoms: [
                      {
                        id: "h1",
                        label: true,
                        name: "H",
                      },
                      {
                        id: "r1",
                        name: "R",
                      },
                    ],
                    bonds: [
                      {
                        id: "h1-r1",
                        source: "h1",
                        target: "r1",
                        type: 1,
                      },
                    ],
                  },
                },
                parentAtom: "r3",
                sourceAtom: "r1",
              },
            ],
            groupId: "3efbb719-95b1-4c25-99bb-81a731cef439",
            isBase: true,
            moleculeId: "46950212-a639-438e-9aa8-ba3add34dbd6",
            options: {
              label: ["c1"],
              showHydrogen: true,
            },
            rangeId: "ff5d5bf2-a5be-43ce-93d1-aa85937445ba-0",
            structure: {
              atoms: [
                {
                  id: "c1",
                  name: "C",
                },
                {
                  id: "r1",
                  name: "R",
                },
                {
                  id: "h1",
                  name: "H",
                },
                {
                  id: "r2",
                  name: "R",
                },
                {
                  id: "r3",
                  name: "R",
                },
              ],
              bonds: [
                {
                  id: "c1-r1",
                  source: "c1",
                  target: "r1",
                  type: 1,
                },
                {
                  id: "c1-h1",
                  source: "c1",
                  target: "h1",
                  type: 1,
                },
                {
                  id: "c1-r2",
                  source: "c1",
                  target: "r2",
                  type: 1,
                },
                {
                  id: "c1-r3",
                  source: "c1",
                  target: "r3",
                  type: 1,
                },
              ],
            },
          },
          parentAtom: "r1",
          sourceAtom: "r1",
        },
      ],
      groupId: "9b9003cc-6259-4acc-bbe5-1665e9630b08",
      isBase: true,
      moleculeId: "71263af6-4652-4113-952c-f3081c24a140",
      options: {
        showHydrogen: true,
      },
      rangeId: "83239b4f-0929-4622-9cbe-d0e4cd6d2140-0",
      structure: {
        atoms: [
          {
            id: "c1",
            name: "C",
          },
          {
            id: "o1",
            name: "O",
          },
          {
            id: "o2",
            name: "O",
          },
          {
            id: "r1",
            name: "R",
          },
          {
            id: "r2",
            name: "R",
          },
          {
            id: "p1",
          },
        ],
        bonds: [
          {
            id: "c1-o1",
            source: "c1",
            target: "o1",
            type: 2,
          },
          {
            id: "c1-o2",
            source: "c1",
            target: "o2",
            type: 1,
          },
          {
            id: "c1-r1",
            source: "c1",
            target: "r1",
            type: 1,
          },
          {
            id: "o2-r2",
            source: "o2",
            target: "r2",
            type: 1,
          },
          {
            id: "o2-p1",
            source: "o2",
            target: "p1",
            type: 0,
          },
        ],
      },
    },
  },
};
